// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:03.963Z
// Property: Pelican Pointe (ID: 6737460151191762)
// Collections: 29 amenities, 19 floorplans (live), 27 photos, 78 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191762",
  "property_external_id": "4973409",
  "property_zillow_url": "https://www.zillow.com/apartments/slidell-la/pelican-pointe/5XhxsJ/",
  "property_apartments_url": "https://www.apartments.com/dlp-pelican-pointe-slidell-la/xq2jm6q",
  "property_google_business_url": "https://www.google.com/maps/place/Pelican+Pointe/data=!4m2!3m1!1s0x0:0x8d253dbcd906a4f1?sa=X&ved=2ahUKEwiF8OTnu7ySAxWnnWoFHYVjIF4Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321245818",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "pelican-pointe",
  "property_name": "Pelican Pointe",
  "property_website_url": "https://www.liveatpelicanpointe.com/",
  "property_domain": "https://www.liveatpelicanpointe.com/",
  "property_address": "3400 Pelican Pointe Dr",
  "property_full_address": "3400 Pelican Pointe Dr, Slidell, LA 70458",
  "property_address_1": "3400 Pelican Pointe Dr",
  "property_address_2": null,
  "property_address_city": "Slidell",
  "property_address_state": "LA",
  "property_address_zip_full": "70458-5398",
  "property_address_zip": "70458",
  "property_address_country": "US",
  "property_address_county": "St. Tammany Parish",
  "property_neighborhood_address": "Outlying St Tammany Parish",
  "property_address_latitude": "30.3123168",
  "property_address_longitude": "-89.74797029999999",
  "property_email": "Pelicanpointe@rrliving.com",
  "property_phone": "(985) 243-4004",
  "property_call_tracking_phone": "985-336-3395",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Pelican Pointe in Slidell, LA, your ideal apartment awaits! Choose from spacious one, two, or three-bedroom floor plans, complemented by luxury amenities like a sparkling pool, fitness center, and serene walking trails. With a pet-friendly environment and exceptional services, this is more than a home—it's a lifestyle.",
  "property_long_description": "Welcome to Pelican Pointe, your ideal apartment community located in the charming city of Slidell, LA. With a variety of thoughtfully designed floor plans, including one-bedroom, two-bedroom, and three-bedroom options, Pelican Pointe caters to diverse lifestyles and preferences. Each residence embodies modern comfort and convenience, making it the perfect place to call home.\n\nAt Pelican Pointe, we believe that exceptional living extends beyond your front door. Our community amenities are crafted to enhance your lifestyle. Dive into relaxation at our sparkling pool, stay fit in our fully equipped fitness center, or unwind at the clubhouse and connect with neighbors. For those who value both work and play, our business center and multi-use room offer ideal spaces for productivity and leisure.\n\nSafety and sustainability are top priorities at Pelican Pointe. Enjoy peace of mind with controlled access, along with door-to-door trash pickup and recycling services available throughout the community. Embrace outdoor living with our beautiful courtyard, sundeck, and scenic walking and biking trails, perfect for enjoying Louisiana’s sunny days.\n\nWith a dedicated property manager on site and convenient online services, our residents experience unparalleled support and care. Plus, your furry friends will love the pet play area! \n\nFind your new home today at Pelican Pointe. Browse our availability or schedule a tour to visit our vibrant community and experience all the features that await you!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-24ca-7701-a4fe-19144e832d31.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a multifamily property with a lake and pool.",
    "public_id": "019e847f-24ca-7701-a4fe-19144e832d31",
    "storage_key": "property/6737460151191762/019e847f-24ca-7701-a4fe-19144e832d31.webp",
    "width": 3072,
    "height": 1920
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "266",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.60902255639097",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets, with a limit of 2 dogs per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://dlppelicanpointe.loftliving.com/login",
  "property_apply_now_url": "https://8873221.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-8cf8-7188-a417-9fa144160255.webp",
  "property_primary_logo_media": {
    "alt_text": "Pelican Pointe logo",
    "public_id": "019e1e3d-8cf8-7188-a417-9fa144160255",
    "storage_key": "property/6737460151191762/019e1e3d-8cf8-7188-a417-9fa144160255.webp",
    "width": 351,
    "height": 61
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847e-c970-721b-9641-af5cab237908.webp",
  "property_secondary_logo_media": {
    "alt_text": "Pelican Pointe logo",
    "public_id": "019e847e-c970-721b-9641-af5cab237908",
    "storage_key": "property/6737460151191762/019e847e-c970-721b-9641-af5cab237908.webp",
    "width": 1463,
    "height": 255
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847e-c970-721b-9641-af5cab237908.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Pelican Pointe logo",
    "public_id": "019e847e-c970-721b-9641-af5cab237908",
    "storage_key": "property/6737460151191762/019e847e-c970-721b-9641-af5cab237908.webp",
    "width": 1463,
    "height": 255
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-8cf2-76fb-b9da-1a2fd8e5bab2.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Pelican Pointe logo",
    "public_id": "019e1e3d-8cf2-76fb-b9da-1a2fd8e5bab2",
    "storage_key": "property/6737460151191762/019e1e3d-8cf2-76fb-b9da-1a2fd8e5bab2.webp",
    "width": 351,
    "height": 61
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "528 - 1400",
  "property_sqft_min": "528",
  "property_sqft_max": "1400",
  "property_price_range": "1120 - 1785",
  "property_price_min": "1120",
  "property_price_max": "1785",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/people/Pelican-Pointe-Apartments/61554548098427/",
  "property_instagram_url": "https://www.instagram.com/Pelican_Pointe_RRliving",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJvX1yg0XmnYgR8aQG2bw9JY0",
  "property_youtube_url": "https://www.youtube.com/shorts/fFM0UFzH8K0",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Slidell%2C+LA",
  "property_tiktok_url": "https://www.tiktok.com/@pelican.pointe",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pelican Pointe",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "<p>Discover unparalleled comfort and luxury living at Pelican Pointe, ideally situated just a short drive from the bustling Fremaux Town Center and a mere 27-minutes from the prestigious Stennis Space Center. Nestled along the tranquil northeast shore of Lake Pontchartrain in Slidell, our <a href=\"/floor-plans/\">apartments</a> offer the perfect blend of <a href=\"/neighborhood/\">convenience</a> and elegance. With New Orleans just a 25-minute commute away via Interstates 10, 12, and 59, and downtown moments from your doorstep, residents enjoy seamless access to mouthwatering dining, tempting shopping, and captivating entertainment attractions.</p>",
  "property_home_floorplans_blurb": "<p>Discover the vibrant community of Slidell, LA, brimming with endless activities and excitement! After taking a tour of Pelican Pointe, witness firsthand the allure of our amazing <a href=\"/neighborhood/\">neighborhood</a>. With easy access to the popular Fremaux Town Center, renowned for its top-tier dining and shopping options, Pelican Pointe epitomizes the essence of North Shore living. Experience the ultimate in coastal luxury at Pelican Pointe - your gateway to unparalleled apartment living in Slidell, LA!</p>",
  "property_home_gallery_blurb": "At Pelican Pointe in Slidell, LA, life is enriched with stylish living spaces—explore our one, two, and three-bedroom floor plans. Enjoy amenities that elevate everyday experiences, from a tranquil pond and sundeck to a vibrant clubhouse. Picture yourself enjoying our community pool and scenic walking trails!",
  "property_home_neighborhood_blurb": "Welcome to Pelican Pointe in Slidell, LA, where vibrant living meets serene surroundings. Our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Uncover the charm of our neighborhood, packed with local favorites and hidden gems waiting to be explored.",
  "property_home_reviews_blurb": "At Pelican Pointe in Slidell, LA, residents thrive in a vibrant community that feels like home. As one resident shared, \"The friendly atmosphere and beautiful surroundings make every day special.\" Dive into their experiences and see what makes living here truly exceptional! Your new adventure awaits!",
  "property_neighborhood_blurb": "<p>Discover the vibrant community of Slidell, LA, brimming with endless activities and excitement! After taking a tour of Pelican Pointe, witness firsthand the allure of our amazing <a href=\"/neighborhood/\">neighborhood</a>. With easy access to the popular Fremaux Town Center, renowned for its top-tier dining and shopping options, Pelican Pointe epitomizes the essence of North Shore living. Experience the ultimate in coastal luxury at Pelican Pointe - your gateway to unparalleled apartment living in Slidell, LA!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Proudly offering a high-end lifestyle in Slidell, LA with our upgraded <a href=\"/floor-plans/\">one, two, and three-bedroom</a> apartments for rent. Our pet-friendly apartment homes are bursting with impeccable and refined features. Quaint city living can be easy and extravagant at Pelican Pointe.</p>",
  "property_applynow_blurb": "At Pelican Pointe in scenic Slidell, LA, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans, and indulge in our outstanding amenities, including a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Ready to elevate your lifestyle? Lease online today and find your perfect fit!",
  "property_contactus_blurb": "At Pelican Pointe in Slidell, LA, our thoughtfully designed floor plans offer one, two, and three-bedroom layouts that cater to your lifestyle. Each spacious apartment exudes comfort and sophistication. Have questions? Reach out to our leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Pelican Pointe in Slidell, LA, we understand that home is more than a floor plan. Whether you seek a cozy one-bedroom or a spacious three-bedroom, our community caters to your lifestyle. Dive into our FAQs and uncover the answers that make Pelican Pointe the perfect place to call home.",
  "property_floorplans_blurb": "<p>The richness of Pelican Pointe follows you outside of your front door. With deluxe <a href=\"/amenities/\">amenities</a> and a jovial management team, residents can experience relaxed leisurely living on a daily basis. Call today and schedule your tour and see what you've been missing in <a href=\"/neighborhood/\">Slidell, LA</a>.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/neighborhood/\">communit</a><a href=\"/neighborhood/\">y</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Pelican Pointe in Slidell, LA, your ideal home awaits! Choose from one, two, or three-bedroom floor plans amid top-tier amenities like a sparkling pool, fitness center, and serene walking trails. Use our interactive community map to uncover your new living space and the vibrant lifestyle that comes with it!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Pelican Pointe in Slidell, LA, comfort meets community in our versatile floor plans—choose from cozy one-bedroom, spacious two-bedroom, or expansive three-bedroom options. Great friends make great neighbors, so refer a friend today and enjoy a vibrant lifestyle together in your new home!",
  "property_residentaccess_blurb": "At Pelican Pointe in Slidell, LA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your unique lifestyle. Seamlessly manage your living experience through our resident portal—pay rent, schedule maintenance, and stay connected with ease! Login today and embrace the convenience of community living.",
  "property_reviews_blurb": "At Pelican Pointe in Slidell, LA, residents rave about the vibrant community and exceptional maintenance. One happy tenant shares, “The staff is always friendly and quick to help.” Curious about the Pelican Pointe lifestyle? See what our residents have to say about living at our community!",
  "property_created_at": "1752257092383",
  "property_scheduletour_blurb": "At Pelican Pointe in Slidell, LA, our thoughtfully designed floor plans—ranging from cozy one-bedroom to spacious three-bedroom options—cater to your unique lifestyle. Ready to experience a vibrant community? Schedule a tour today and hear firsthand from our residents why Pelican Pointe feels like home! ",
  "property_thankyou_blurb": "Thank you for reaching out to Pelican Pointe in Slidell, LA! Our spacious one, two, and three-bedroom floor plans are designed for comfort and style. A team member will connect with you soon to explore how our vibrant community can elevate your living experience. Get ready for your next chapter!",
  "property_virtualtours_blurb": "<p>At Pelican Pointe, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Pelican Pointe",
  "property_seo_title_home": "Pelican Pointe | Apartments in Slidell, LA",
  "property_seo_description_home": "Experience the vibrant lifestyle at Pelican Pointe in Slidell, LA, where comfort meets convenience. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, and indulge in exceptional amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Enjoy gated security, online services, and on-site management for ultimate peace of mind. Unwind in our landscaped courtyards, explore scenic walking and biking trails, or pamper your pets in the dedicated play area. Your new home awaits—take the first step to elevate your living today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Slidell, LA",
  "property_seo_description_floorplans": "Experience the charm of Pelican Pointe in Slidell, LA, where your ideal home awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Each space is crafted for comfort and convenience. Take a moment to browse our available apartment homes and uncover the perfect layout tailored just for you. ",
  "property_seo_title_amenities": "Amenities | Slidell, LA Apartments for Rent",
  "property_seo_description_amenities": "\"Welcome to Pelican Pointe in Slidell, LA, where urban living meets serene comfort. Our community is designed for every lifestyle with stunning one, two, and three-bedroom floor plans and impressive amenities like a refreshing pool, state-of-the-art fitness center, and a relaxing spa. Enjoy the convenience of door-to-door trash pickup, online services, and a dedicated property manager on site. With inviting walking and biking trails, a lounge, and a vibrant clubhouse, Pelican Pointe is your perfect retreat. Take a leap into a life of luxury and community—your new home awaits!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Slidell, LA",
  "property_seo_description_gallery": "\"Step into the vibrant lifestyle at Pelican Pointe in Slidell, LA, where every photo tells a story of comfort and community. From spacious one, two, and three-bedroom floor plans to resort-style amenities like a sparkling pool, fitness center, and a pet play area, this is a place you'll be proud to call home. Picture yourself lounging by the sundeck, enjoying the multi-use room, or strolling the scenic walking trails. Your ideal living space awaits — the pictures say it all!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Pelican Pointe Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Pelican Pointe in Slidell, LA, where modern living meets serene surroundings. Our diverse floor plans—one, two, and three-bedroom options—cater to every lifestyle. Ready to see it for yourself? Dive into our virtual tour and step into your future home today!",
  "property_seo_title_interactivemap": "Interactive Map | Pelican Pointe Apartments",
  "property_seo_description_interactivemap": "\"Unveil the vibrant lifestyle waiting for you at Pelican Pointe in Slidell, LA. With a variety of spacious floor plans, luxurious amenities including a pool, state-of-the-art fitness center, and pet-friendly spaces, your perfect home is just a click away. Navigate our interactive community map to uncover available apartments, pricing options, and the ideal layout for your next chapter. Welcome to comfort, convenience, and community!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Slidell, LA",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of Pelican Pointe in Slidell, LA! Nestled in a dynamic neighborhood, our apartment community offers a perfect blend of comfort and convenience. Uncover local favorites, parks, dining, and entertainment just steps away from your door. Embrace the energy of your surroundings and see what makes this community truly special!",
  "property_seo_title_contact": "Contact Us | Pelican Pointe",
  "property_seo_description_contact": "Experience the charm of Pelican Pointe in Slidell, LA, where your perfect apartment awaits! From cozy one-bedroom retreats to spacious three-bedroom havens, our diverse floor plans cater to every lifestyle. Ready to learn more? Reach out to our friendly leasing team today with any questions you might have!",
  "property_seo_title_faqs": "FAQs | Apartments in Slidell, LA",
  "property_seo_description_faqs": "\"At Pelican Pointe in Slidell, LA, we redefine coastal living with stylish one, two, and three-bedroom floor plans and remarkable amenities like a refreshing pool, state-of-the-art fitness center, and serene walking trails. Curious about our community? Our FAQs page offers insights into our gated access, pet-friendly vibe, and more. Dive into your new lifestyle and find the answers you need today!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Slidell, LA",
  "property_seo_description_reviews": "\"At Pelican Pointe in Slidell, LA, your ideal home awaits! Delve into our spacious one, two, and three-bedroom floor plans and experience unparalleled amenities like a sparkling pool, fitness center, and serene walking trails. With a dedicated property manager and door-to-door trash pickup, enjoy the comfort and convenience of modern living. Curious about community vibes? See what our residents have to say about life at Pelican Pointe!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Slidell, LA",
  "property_seo_description_applynow": "Experience a lifestyle of comfort and convenience at Pelican Pointe in Slidell, LA. Choose from spacious one, two, or three-bedroom floor plans designed to suit your needs. Enjoy an array of amenities including a sparkling pool, state-of-the-art fitness center, and a relaxing spa. Nestled within a gated community, community features like walking trails, a sundeck, and a pet play area promote a vibrant, outdoor lifestyle. With online leasing and attentive on-site management, your new home awaits. Apply now and embrace the Pelican Pointe experience today!",
  "property_seo_title_residentaccess": "Resident Access | Pelican Pointe",
  "property_seo_description_residentaccess": "\"Welcome home to Pelican Pointe in Slidell, LA! Seamlessly manage your living experience with our resident portal—pay rent, schedule maintenance, and stay connected. Your comfort is just a click away!\"",
  "property_seo_title_referafriend": "Refer A Friend | Pelican Pointe",
  "property_seo_description_referafriend": "\"At Pelican Pointe in Slidell, LA, friendships flourish! Share the joy of vibrant community living and refer a friend today. Your great neighbors await!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Pelican Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Pelican Pointe in Slidell, LA! Immerse yourself in our vibrant community, where modern amenities meet serene living. Ready to see your future home? Schedule a tour today and envision your new lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Pelican Pointe",
  "property_seo_description_privacy": "At Pelican Pointe in Slidell, LA, your privacy is our priority. Delve into the details of our commitment to safeguarding your information and ensuring a secure living environment. Curious about how we protect you? View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Pelican Pointe",
  "property_seo_description_accessibility": "\"At Pelican Pointe in Slidell, LA, we prioritize accessibility and digital inclusion for all. Our commitment ensures that everyone can easily navigate our community resources. Join us in creating a welcoming and accessible environment!\"",
  "property_seo_title_sitemap": "Sitemap | Pelican Pointe",
  "property_seo_description_sitemap": "\"Navigate your way to comfort and style at Pelican Pointe in Slidell, LA. Our sitemap guides you through a community where modern living meets Southern charm. Uncover every amenity and feature that makes Pelican Pointe your perfect home—view our sitemap today!\"",
  "property_seo_title_thankyou": "Thank You | Pelican Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Pelican Pointe in Slidell, LA! Your inquiry is on its way, and our friendly team is eager to connect with you about your future home. Get ready to embrace a lifestyle of comfort and convenience in a vibrant community tailored just for you. Stay tuned for our response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Slidell, LA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293615126",
  "amenities": [
    {
      "id": "ec_459be9a947c526cd6c2c0f0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "2 Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6c60cbf3a410c1a4eef7c6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f4e75b16ebb201e1ee80962",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Self Serve Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3cdb0158083d1c487f6dd6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_face281669d3c349d08d736f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Community Walking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13a171b0a0290c43c4123d38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Full‑circuit Fitness Center with Cardio Equipment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df1166bf8413b7ecd22029ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Military Discounts",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c97b999c10c0ba720f6bed11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Package Locker System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24abfa4dc22f82fd5b81f769",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1bacd68f61768238d7a3939",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_890f75f5688db4d1e58add69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07aaa1889d9ef186ccff64bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe4a6056c19e3ebcf6a6910e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Outdoor Entertainment Terrace with Fire Pits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c913481d1b6caf1118e8ef72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Social Sundeck with Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_649a534582ff2b5864624b81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Sport Court with Foosball, Cornhole, Game Tables and More",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58f7e66c17649b05795d6f85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b4e5ae956f566215e4fa969",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Chef‑ready Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb6499242eaab9232a7ddf7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_915e1728e294231d8f2776cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher, Microwave and Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71dd94eb9fdd03fbc596e6aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Energy‑efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01674b854aa0e6fad6984bfe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Patios and Balconies with Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03f8f05e46437cca6d694320",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Walk‑in Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a49187b7f9364ba017153710",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Style Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5c2926af14c1de411983ae1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Luxury Wood‑designed Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2cf7e76e764822d3a7155b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Open‑concept Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3ce10c980935bd3460a932c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Oversized Laundry Room with Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c347668bf6c486388c72222b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Smart Outlets with USB Charging*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b6ba2f784d5b5b0e7832e74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Soaking Tubs*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a770e32ba7874de536da26eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_56b47d7e-0a16-4fd8-ae78-b556d7a09ea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1b7a-70f8-a41b-e7e51dd5bbe9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a06dc2-1b7a-70f8-a41b-e7e51dd5bbe9",
        "storage_key": "property/6737460151191762/01a06dc2-1b7a-70f8-a41b-e7e51dd5bbe9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_038295b5-41d9-465c-afa8-98f92032178a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1b10-7619-bf67-e8d8afc3280b.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchairs, coffee table, and dining area in the background.",
        "public_id": "01a06dc2-1b10-7619-bf67-e8d8afc3280b",
        "storage_key": "property/6737460151191762/01a06dc2-1b10-7619-bf67-e8d8afc3280b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a comfortable sofa, stylish armchairs, a modern coffee table, and a separate dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchairs, coffee table, and dining area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a6da0d1-1434-4505-8fae-ce40c403f1b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-77d6-775e-888b-4367c5957a9a.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, green accents, and a large mirror.",
        "public_id": "01a06dc2-77d6-775e-888b-4367c5957a9a",
        "storage_key": "property/6737460151191762/01a06dc2-77d6-775e-888b-4367c5957a9a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bedrooms, designed for relaxation and tranquility.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, green accents, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7431a83-3857-47f3-9c2a-bfcf8a1db9f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1aad-777c-b847-b0cc52fc429f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and subway tile backsplash.",
        "public_id": "01a06dc2-1aad-777c-b847-b0cc52fc429f",
        "storage_key": "property/6737460151191762/01a06dc2-1aad-777c-b847-b0cc52fc429f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into this sleek kitchen featuring crisp white cabinetry, granite countertops, and a stylish subway tile backsplash. Fully equipped with black appliances, it's perfect for your culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13d640de-2a9e-47b1-ba63-11ced4c9e82e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1b1e-768d-9e33-d5a94124651b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, mirror, and bathtub.",
        "public_id": "01a06dc2-1b1e-768d-9e33-d5a94124651b",
        "storage_key": "property/6737460151191762/01a06dc2-1b1e-768d-9e33-d5a94124651b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy a spa-like experience in this beautifully appointed bathroom, featuring a spacious vanity and a clean, modern bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, mirror, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_238a38ce-ba72-48eb-9945-b6b7e18e2b17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-14fa-701a-bc70-5ffd121a6bdb.webp",
      "image_media": {
        "alt_text": "Community lounge area with a shuffleboard table, comfortable seating, and a fireplace.",
        "public_id": "01a06dc2-14fa-701a-bc70-5ffd121a6bdb",
        "storage_key": "property/6737460151191762/01a06dc2-14fa-701a-bc70-5ffd121a6bdb.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy fun and games in our community lounge, featuring a shuffleboard table and ample seating for residents.",
      "link": "",
      "alt_text": "Community lounge area with a shuffleboard table, comfortable seating, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bca25d75-0119-4716-aef2-9f9187fc0440",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-14c3-7658-9c33-f71f2b13f68b.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "01a06dc2-14c3-7658-9c33-f71f2b13f68b",
        "storage_key": "property/6737460151191762/01a06dc2-14c3-7658-9c33-f71f2b13f68b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad29223a-be0f-413f-943f-dcb3913c9879",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1aac-710b-acb9-4cce5dd3b148.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area at a multifamily property.",
        "public_id": "01a06dc2-1aac-710b-acb9-4cce5dd3b148",
        "storage_key": "property/6737460151191762/01a06dc2-1aac-710b-acb9-4cce5dd3b148.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing and soaking up the sun. Lounge chairs and a covered seating area provide ample space for leisure.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35cb7b3d-2f4a-4a54-850a-543325391460",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1bc3-7606-b0db-3e177249622d.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and a cabana.",
        "public_id": "01a06dc2-1bc3-7606-b0db-3e177249622d",
        "storage_key": "property/6737460151191762/01a06dc2-1bc3-7606-b0db-3e177249622d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing or entertaining guests. Lounge chairs and a cabana are available for your comfort.",
      "link": "",
      "alt_text": "Community swimming pool with lounge chairs and a cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_860f86bc-be00-4c35-87dc-50eaea346bf3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/01a06dc2-1458-7668-b2a6-3baf1046ee09.webp",
      "image_media": {
        "alt_text": "Soccer field with goal and seating area",
        "public_id": "01a06dc2-1458-7668-b2a6-3baf1046ee09",
        "storage_key": "property/6737460151191762/01a06dc2-1458-7668-b2a6-3baf1046ee09.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our artificial turf soccer field, complete with a full-sized goal and comfortable seating for spectators.",
      "link": "",
      "alt_text": "Soccer field with goal and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2dc75066-3ec7-4694-a5b8-ca3f85b1ee9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e8480-04f1-72fe-9649-85d5bdd02a92.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with swimming pool and lake.",
        "public_id": "019e8480-04f1-72fe-9649-85d5bdd02a92",
        "storage_key": "property/6737460151191762/019e8480-04f1-72fe-9649-85d5bdd02a92.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Discover this apartment community featuring a sparkling swimming pool and serene lake, offering a picturesque living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with swimming pool and lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26e8d9e0-ff07-42cc-b318-4f2f8daf3a4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-6506-75cb-b3f1-8a48377670ce.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and exercise balls.",
        "public_id": "019e847f-6506-75cb-b3f1-8a48377670ce",
        "storage_key": "property/6737460151191762/019e847f-6506-75cb-b3f1-8a48377670ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d264a8ef-8236-45c7-8fbb-6f043487c184",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-5ba6-76d7-bb11-e076436b8a91.webp",
      "image_media": {
        "alt_text": "Community lounge area with large sectional sofa, shuffleboard table, dining table, fireplace, and TV.",
        "public_id": "019e847f-5ba6-76d7-bb11-e076436b8a91",
        "storage_key": "property/6737460151191762/019e847f-5ba6-76d7-bb11-e076436b8a91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and entertain in our spacious community lounge, featuring a cozy fireplace, comfortable seating, a shuffleboard table, and a dining area.",
      "link": "",
      "alt_text": "Community lounge area with large sectional sofa, shuffleboard table, dining table, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ce2e21d-bc88-4b08-808b-89d963f9760a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-9d1b-700d-b1b2-95d797a3614d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and granite countertops.",
        "public_id": "019e847f-9d1b-700d-b1b2-95d797a3614d",
        "storage_key": "property/6737460151191762/019e847f-9d1b-700d-b1b2-95d797a3614d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinets, granite countertops, a black stove, microwave, dishwasher, and refrigerator. Includes a stainless steel sink and laminate flooring.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e2b36692-bf49-4cff-9abb-fd6bd9a8ce6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-78e3-766c-8e82-5671bd2720b3.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e847f-78e3-766c-8e82-5671bd2720b3",
        "storage_key": "property/6737460151191762/019e847f-78e3-766c-8e82-5671bd2720b3.webp",
        "width": 3072,
        "height": 2129
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a spacious vanity with granite countertops, a clean white toilet, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21df188a-f66f-4077-b46b-b11db86769bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-c070-7269-b9f3-76bfaabd4ac5.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and a window.",
        "public_id": "019e847f-c070-7269-b9f3-76bfaabd4ac5",
        "storage_key": "property/6737460151191762/019e847f-c070-7269-b9f3-76bfaabd4ac5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This is an empty bedroom with soft carpet, a window with blinds, and a neutral wall color.",
      "link": "",
      "alt_text": "Empty bedroom with carpet and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6ab7460c-cd40-4e16-8236-273ba0c82352",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-bab8-7483-a869-f157d2690c84.webp",
      "image_media": {
        "alt_text": "Empty living room with grey wood-look flooring and a ceiling fan.",
        "public_id": "019e847f-bab8-7483-a869-f157d2690c84",
        "storage_key": "property/6737460151191762/019e847f-bab8-7483-a869-f157d2690c84.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with ample natural light and a modern ceiling fan, perfect for any lifestyle.",
      "link": "",
      "alt_text": "Empty living room with grey wood-look flooring and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd14e76c-d812-40fb-8435-e34a41112b84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-8fb1-747e-82f1-bad1c8a137e8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral walls, a ceiling fan, and carpeted floor.",
        "public_id": "019e847f-8fb1-747e-82f1-bad1c8a137e8",
        "storage_key": "property/6737460151191762/019e847f-8fb1-747e-82f1-bad1c8a137e8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting and a modern ceiling fan, ready for you to make it your own.",
      "link": "",
      "alt_text": "Empty bedroom with neutral walls, a ceiling fan, and carpeted floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e39e86dc-6879-4185-83b3-9a9a1f0ab2f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-e09e-712f-8af3-be6e49469a11.webp",
      "image_media": {
        "alt_text": "Outdoor recreational area with picnic tables, Adirondack chairs, a ping pong table, and a soccer goal.",
        "public_id": "019e847f-e09e-712f-8af3-be6e49469a11",
        "storage_key": "property/6737460151191762/019e847f-e09e-712f-8af3-be6e49469a11.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with picnic tables, Adirondack chairs, a ping pong table, and a soccer field, perfect for gatherings and activities.",
      "link": "",
      "alt_text": "Outdoor recreational area with picnic tables, Adirondack chairs, a ping pong table, and a soccer goal.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef251391-a2a4-4ccb-a5e1-651badbf05dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-fa7d-778b-8379-ea676b66c2fe.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex buildings surrounding a swimming pool and pond.",
        "public_id": "019e847f-fa7d-778b-8379-ea676b66c2fe",
        "storage_key": "property/6737460151191762/019e847f-fa7d-778b-8379-ea676b66c2fe.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Spacious apartment complex with lush landscaping, a sparkling swimming pool, and serene water features, offering a perfect blend of comfort and convenience.",
      "link": "",
      "alt_text": "Aerial view of apartment complex buildings surrounding a swimming pool and pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8b07f5d-9e92-412d-a512-76526320a8cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e8480-0ae3-7149-a0ff-634fc1bed7b3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a lake with a pool and clubhouse.",
        "public_id": "019e8480-0ae3-7149-a0ff-634fc1bed7b3",
        "storage_key": "property/6737460151191762/019e8480-0ae3-7149-a0ff-634fc1bed7b3.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Experience resort-style living with our beautiful lake, sparkling pool, and clubhouse. Enjoy the serene views and vibrant community atmosphere.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounding a lake with a pool and clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec0db70c-cc31-4946-afc4-105bc0a9265e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e8480-0330-7315-b1f2-8cc653991c5a.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and clubhouse on a lake.",
        "public_id": "019e8480-0330-7315-b1f2-8cc653991c5a",
        "storage_key": "property/6737460151191762/019e8480-0330-7315-b1f2-8cc653991c5a.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, adjacent to a serene lake. Perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and clubhouse on a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2de69a54-cb0e-4106-a463-4a835b1a999f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-f7c8-758d-8425-365666ec08da.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a pond",
        "public_id": "019e847f-f7c8-758d-8425-365666ec08da",
        "storage_key": "property/6737460151191762/019e847f-f7c8-758d-8425-365666ec08da.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Beautiful aerial view showcasing the apartment buildings and serene pond, highlighting the community's scenic setting.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a pond",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ece58315-1a27-4c2a-8f8a-b5a2b9d4a8db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-df03-7658-a539-766be4a56cf0.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with a swimming pool and pond.",
        "public_id": "019e847f-df03-7658-a539-766be4a56cf0",
        "storage_key": "property/6737460151191762/019e847f-df03-7658-a539-766be4a56cf0.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Experience resort-style living with our beautiful swimming pool and serene pond, surrounded by lush greenery and well-maintained apartment buildings.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with a swimming pool and pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12526bb8-7dd2-4309-84a1-8cf07962ada0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-e302-75df-a724-83ea39719544.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured lawn and pathways",
        "public_id": "019e847f-e302-75df-a724-83ea39719544",
        "storage_key": "property/6737460151191762/019e847f-e302-75df-a724-83ea39719544.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround the exterior of this apartment building, featuring spacious balconies and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment building with manicured lawn and pathways",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40f494e7-ff10-4077-a7a5-7ed60fd54e01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-d097-7774-8bbc-34052aaa28e5.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a lake in the foreground.",
        "public_id": "019e847f-d097-7774-8bbc-34052aaa28e5",
        "storage_key": "property/6737460151191762/019e847f-d097-7774-8bbc-34052aaa28e5.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Serene apartment buildings with a tranquil lake in the foreground, offering a peaceful living environment.",
      "link": "",
      "alt_text": "Apartment buildings with a lake in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8c8eea9-0bfb-409c-90eb-de7f1ad00b51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e847f-d6eb-770e-9390-303d4a1ceb49.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and green lawn.",
        "public_id": "019e847f-d6eb-770e-9390-303d4a1ceb49",
        "storage_key": "property/6737460151191762/019e847f-d6eb-770e-9390-303d4a1ceb49.webp",
        "width": 3072,
        "height": 1920
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with ample parking and lush green spaces, offering a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e3d6392c-59fe-4171-a94c-3981725f0082",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Phil's Marina Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1194 Harbor Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Casual eatery specializing in familiar Louisianan seafood dishes, such as po’ boys & crawfish.",
      "poi_long_description": "Casual eatery specializing in familiar Louisianan seafood dishes, such as po’ boys & crawfish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-705c-741d-8c3c-4cb06aa7ce47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-705c-741d-8c3c-4cb06aa7ce47",
        "storage_key": "property/6737460151191762/019e1e3f-705c-741d-8c3c-4cb06aa7ce47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philsmarinacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3898641026847030078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phils-marina-cafe",
      "poi_latitude": "30.2178952",
      "poi_longitude": "-89.79006299999999",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 985-641-0464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9xv_cXjnYgRPjv7p1vBGjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_11656065-ff72-41f3-b462-420b80edc0fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Middendorf's Slidell",
      "poi_type": "Restaurants",
      "poi_address": "1951 Oak Harbor Blvd, Slidell, LA 70461, USA",
      "poi_short_description": "Seafood restaurant serving fried catfish and other classic Cajun fare, such as gumbo.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-6ffd-766a-a1b3-6789107ef6b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-6ffd-766a-a1b3-6789107ef6b1",
        "storage_key": "property/6737460151191762/019e1e3f-6ffd-766a-a1b3-6789107ef6b1.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://middendorfsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2404309051175697304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middendorfs-slidell",
      "poi_latitude": "30.2206974",
      "poi_longitude": "-89.7799682",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 985-771-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_A3ly7jnYgRmHuV7VfSXSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_25b3e762-a196-44e6-8552-3823b1c19b75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Peck's Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2315 Gause Blvd E, Slidell, LA 70461, USA",
      "poi_short_description": "Creative seafood dishes & sandwiches round out the menu at this casual spot with lunch specials.",
      "poi_long_description": "Creative seafood dishes & sandwiches round out the menu at this casual spot with lunch specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7009-772f-85ba-04cca48bbcd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7009-772f-85ba-04cca48bbcd4",
        "storage_key": "property/6737460151191762/019e1e3f-7009-772f-85ba-04cca48bbcd4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pecksseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4560496660990356114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pecks-seafood-restaurant",
      "poi_latitude": "30.2888922",
      "poi_longitude": "-89.7272148",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 985-781-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1V5tDA_nnYgRkmqv9YwjSj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_16684583-79de-4ffb-ab41-cfc893b601cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "La Pines Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1061 Robert Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Casual diner-style joint with American comfort food served for breakfast, lunch & dinner.",
      "poi_long_description": "Casual diner-style joint with American comfort food served for breakfast, lunch & dinner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7059-76e0-a2bd-e9d44f159403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7059-76e0-a2bd-e9d44f159403",
        "storage_key": "property/6737460151191762/019e1e3f-7059-76e0-a2bd-e9d44f159403.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lapinescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8950462789479678969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-pines-cafe",
      "poi_latitude": "30.289291",
      "poi_longitude": "-89.77110499999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 985-641-6196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bYdhoPmnYgR-cNJRnxuNnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bbddf28a-d727-45d8-ae90-872fe2494bee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Southside Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3154 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Unpretentious standby serving hearty American fare, beer & cocktails in a bustling space.",
      "poi_long_description": "Unpretentious standby serving hearty American fare, beer & cocktails in a bustling space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-3729-71e7-9c01-5802b5defcb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-3729-71e7-9c01-5802b5defcb1",
        "storage_key": "property/6737460151191762/019e1e3d-3729-71e7-9c01-5802b5defcb1.webp",
        "width": 544,
        "height": 364
      },
      "poi_business_url": "http://www.southsidecafe.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=613862466219099344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-cafe",
      "poi_latitude": "30.2601723",
      "poi_longitude": "-89.78583139999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-643-6133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YtN-g_knYgR0ETvH6nghAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7b3f7d35-0e22-4a73-a220-832f28eee35d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Bonnie C's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1768 Front St, Slidell, LA 70458, USA",
      "poi_short_description": "Charming eatery serving cafe fare along with po’ boy sandwiches, pasta dishes & other comfort fare.",
      "poi_long_description": "Charming eatery serving cafe fare along with po’ boy sandwiches, pasta dishes & other comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-74fc-760b-816a-28ee7a773fb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-74fc-760b-816a-28ee7a773fb0",
        "storage_key": "property/6737460151191762/019e1e3f-74fc-760b-816a-28ee7a773fb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=61556145784869",
      "poi_directions_map_url": "https://maps.google.com/?cid=5519376377920563568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonnie-cs-cafe",
      "poi_latitude": "30.2786962",
      "poi_longitude": "-89.7820721",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-288-5061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-Z7lyPknYgRcCmjo5LDmEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_07e08294-cd2e-4bd7-b807-39d27b7b93a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Los Cantaritos",
      "poi_type": "Restaurants",
      "poi_address": "3112 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Casual restaurant serving Mexican dishes such as fajitas and burritos, plus margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-743a-70f3-8c3e-b1fb170bfc44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-743a-70f3-8c3e-b1fb170bfc44",
        "storage_key": "property/6737460151191762/019e1e3f-743a-70f3-8c3e-b1fb170bfc44.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.loscantaritosgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15364343027426436644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-cantaritos",
      "poi_latitude": "30.26159029999999",
      "poi_longitude": "-89.7851204",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-288-0702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZev6OzlnYgRJKYAZZQcOdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_df9e8fff-5d5e-4578-849e-f6352e46cd78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Flatland Coffee",
      "poi_type": "Restaurants",
      "poi_address": "2132 Gause Blvd E Suite 2, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-6fb1-714b-a45f-63def181e994.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-6fb1-714b-a45f-63def181e994",
        "storage_key": "property/6737460151191762/019e1e3f-6fb1-714b-a45f-63def181e994.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.toasttab.com/online/flatland-coffee-3042-gause-blvd-e",
      "poi_directions_map_url": "https://maps.google.com/?cid=5520232176370377423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flatland-coffee",
      "poi_latitude": "30.2875683",
      "poi_longitude": "-89.7346558",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 985-265-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4bc-77bd-ba44-1198243f85ad",
        "storage_key": "property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJJ3kcLEDnnYgRz-I8vurNm0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c847b9c1-1532-4c10-8250-bf53f2038f3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Sirincci Coffee Company | Olde Towne",
      "poi_type": "Restaurants",
      "poi_address": "1808 Front St, Slidell, LA 70458, USA",
      "poi_short_description": "Coffee shop offering the classics plus specials, plus pastries, and gluten-free treats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-75e6-728b-bee7-cfe5d10f3060.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-75e6-728b-bee7-cfe5d10f3060",
        "storage_key": "property/6737460151191762/019e1e3f-75e6-728b-bee7-cfe5d10f3060.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sirincci.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14014539777699434899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sirincci-coffee-company--olde-towne",
      "poi_latitude": "30.2782687",
      "poi_longitude": "-89.7820186",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-612-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4bc-77bd-ba44-1198243f85ad",
        "storage_key": "property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJc_D09HjlnYgRk1Fb9KylfcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_f18d6076-dae4-412a-9449-b82354807afd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Roots Plants + Coffee",
      "poi_type": "Restaurants",
      "poi_address": "124 Erlanger Ave Suite B, Slidell, LA 70458, USA",
      "poi_short_description": "Tropical, quaint coffee shop with houseplants for sale, plus sofas, tables for casual bites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-742d-718e-a0e9-202966e09124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-742d-718e-a0e9-202966e09124",
        "storage_key": "property/6737460151191762/019e1e3f-742d-718e-a0e9-202966e09124.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "http://www.rootsplantsandcoffeeshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16218049824115904375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roots-plants--coffee",
      "poi_latitude": "30.27658169999999",
      "poi_longitude": "-89.7828736",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 504-276-2876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4bc-77bd-ba44-1198243f85ad",
        "storage_key": "property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJcRndeRLlnYgRd88DXGMWEuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c7979ad9-ac97-46bb-a0bc-5de58f0bf6c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Creole Bagelry and Café",
      "poi_type": "Restaurants",
      "poi_address": "1337 Gause Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Breakfast dishes, bagels, pastries, king cakes & sandwiches offered in a casual environment.",
      "poi_long_description": "Breakfast dishes, bagels, pastries, king cakes & sandwiches offered in a casual environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-731e-736b-ae5c-8d96c6380488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-731e-736b-ae5c-8d96c6380488",
        "storage_key": "property/6737460151191762/019e1e3f-731e-736b-ae5c-8d96c6380488.webp",
        "width": 960,
        "height": 589
      },
      "poi_business_url": "http://www.creolebagelry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=970597911338366418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creole-bagelry-and-caf",
      "poi_latitude": "30.2841796",
      "poi_longitude": "-89.76237479999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 985-649-6151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4bc-77bd-ba44-1198243f85ad",
        "storage_key": "property/6737460151191762/019e1e3f-a4bc-77bd-ba44-1198243f85ad.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ6bo3MZDmnYgR0jUPbahBeA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_0161412f-07aa-482b-abd1-0ca91b14261f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Northern Lites",
      "poi_type": "Restaurants",
      "poi_address": "1503 Gause Blvd #105, Slidell, LA 70458, USA",
      "poi_short_description": "Southern-inspired comfort food, including seafood platters and steaks, served in a casual lounge.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7ad1-7668-803c-c4c077ab38f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7ad1-7668-803c-c4c077ab38f9",
        "storage_key": "property/6737460151191762/019e1e3f-7ad1-7668-803c-c4c077ab38f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://northernlitesgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2951027720025134665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northern-lites",
      "poi_latitude": "30.2839577",
      "poi_longitude": "-89.7578219",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-201-7388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aqs-Q3nnYgRSdZtfhMo9Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_728e9ed7-d124-4884-9ab3-f5d7be150c4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Palmettos On The Bayou",
      "poi_type": "Restaurants",
      "poi_address": "1901 Bayou Ln, Slidell, LA 70458, USA",
      "poi_short_description": "Charming destination for Louisiana cuisine in a rustic setting with a lush deck alongside the bayou.",
      "poi_long_description": "Charming destination for Louisiana cuisine in a rustic setting with a lush deck alongside the bayou.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-78ca-7107-88a0-93d8d37e93a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-78ca-7107-88a0-93d8d37e93a3",
        "storage_key": "property/6737460151191762/019e1e3f-78ca-7107-88a0-93d8d37e93a3.webp",
        "width": 620,
        "height": 393
      },
      "poi_business_url": "http://www.palmettosrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6530005227640499234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmettos-on-the-bayou",
      "poi_latitude": "30.2773133",
      "poi_longitude": "-89.7850545",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-643-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0LeGCPknYgRIqz0Nig9n1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a0227234-3969-4e7b-988c-545d673b6dfe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Kenney Seafood",
      "poi_type": "Restaurants",
      "poi_address": "400 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Laid-back venue for Louisiana-style fare like fried seafood platters and po'boys plus a fresh seafood market.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-3850-7283-91cb-deaeb89dd46c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-3850-7283-91cb-deaeb89dd46c",
        "storage_key": "property/6737460151191762/019e1e3d-3850-7283-91cb-deaeb89dd46c.webp",
        "width": 550,
        "height": 413
      },
      "poi_business_url": "https://kenneyseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12493338630077086563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenney-seafood",
      "poi_latitude": "30.26529439999999",
      "poi_longitude": "-89.784876",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 985-643-2717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3YpOYQDlnYgRY_tooEpBYa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a0dd61f7-2cd9-4b9f-a99c-20df55944d8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3130 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-79af-715b-be98-3244bbfebdf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-79af-715b-be98-3244bbfebdf0",
        "storage_key": "property/6737460151191762/019e1e3f-79af-715b-be98-3244bbfebdf0.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.walmart.com/store/6588-slidell-la/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5121877620271364308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "30.2607396",
      "poi_longitude": "-89.78398949999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-288-6518",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6682-703e-bf50-c389190927e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6682-703e-bf50-c389190927e7",
        "storage_key": "property/6737460151191762/019e1e3d-6682-703e-bf50-c389190927e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM__0vQ_knYgR1DhMC4-QFEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4881e1cb-7c79-4a43-9c5f-b1dfdf0cd267",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "3030 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-79c4-75d6-9a35-54250e016a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-79c4-75d6-9a35-54250e016a5d",
        "storage_key": "property/6737460151191762/019e1e3f-79c4-75d6-9a35-54250e016a5d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/la/slidell/3030-pontchartrain-dr/fp09",
      "poi_directions_map_url": "https://maps.google.com/?cid=15679555402098538281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "30.26184",
      "poi_longitude": "-89.78384",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6682-703e-bf50-c389190927e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6682-703e-bf50-c389190927e7",
        "storage_key": "property/6737460151191762/019e1e3d-6682-703e-bf50-c389190927e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFxB8WYnlnYgRKfcjepD4mNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9d2836bb-cf6e-47e0-8f18-34cf6de2a2e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Rouses Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1644 Gause Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Supermarket chain offering produce, meat & seafood, plus grab-&-go dinners & beer.",
      "poi_long_description": "Supermarket chain offering produce, meat & seafood, plus grab-&-go dinners & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-3aae-769d-ad7e-b6f297ac9c44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-3aae-769d-ad7e-b6f297ac9c44",
        "storage_key": "property/6737460151191762/019e1e3d-3aae-769d-ad7e-b6f297ac9c44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rouses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8972694672322782307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rouses-market",
      "poi_latitude": "30.286166",
      "poi_longitude": "-89.75276699999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-646-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6682-703e-bf50-c389190927e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6682-703e-bf50-c389190927e7",
        "storage_key": "property/6737460151191762/019e1e3d-6682-703e-bf50-c389190927e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxrQku3mnYgRY-TW3UNqhXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_17fb9fd3-e2d4-4d5c-88f0-914e51f6e27a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2103 Gause Blvd E, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7ba5-772c-b368-8181308227d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7ba5-772c-b368-8181308227d5",
        "storage_key": "property/6737460151191762/019e1e3f-7ba5-772c-b368-8181308227d5.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/slidell-la-pharmacies/2103-gause-blvd-east-slidell-la-70461/storeid=5473?WT.mc_id=LS_GOOGLE_RX_5473",
      "poi_directions_map_url": "https://maps.google.com/?cid=5894620048439198549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.286275",
      "poi_longitude": "-89.73580799999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-643-5743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4ce-7575-b503-0400be4b57f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4ce-7575-b503-0400be4b57f4",
        "storage_key": "property/6737460151191762/019e1e3f-a4ce-7575-b503-0400be4b57f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6YV1gLnnYgRVUMd-bPlzVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6955a275-a486-434c-92f8-d80e354240b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "3818 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7c2a-760f-823d-45535a796b84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7c2a-760f-823d-45535a796b84",
        "storage_key": "property/6737460151191762/019e1e3f-7c2a-760f-823d-45535a796b84.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/la/slidell/11409",
      "poi_directions_map_url": "https://maps.google.com/?cid=3932987433194586562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "30.2534074",
      "poi_longitude": "-89.7895753",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 985-282-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJESGDQArknYgRwoGjjTvHlDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_f9c63949-926f-4823-9414-4a126e4020e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7dfb-77fa-bd71-770a5aa4e880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7dfb-77fa-bd71-770a5aa4e880",
        "storage_key": "property/6737460151191762/019e1e3f-7dfb-77fa-bd71-770a5aa4e880.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/la/slidell/4000-pontchartrain-dr?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8593160954898285767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "30.249411",
      "poi_longitude": "-89.79139909999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 985-259-6540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxXE1d_XjnYgRxwR4JlwKQXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_8147e706-3990-4975-8f71-6222c024fe24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "STOP 2 SHOP",
      "poi_type": "Shopping & Retail",
      "poi_address": "580 Robert Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Easygoing restaurant serving up Mediterranean comfort food and quick bites, including vegetarian and halal options, for breakfast, lunch, dinner, and late-night meals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7fc9-7623-b228-f3d78124968a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7fc9-7623-b228-f3d78124968a",
        "storage_key": "property/6737460151191762/019e1e3f-7fc9-7623-b228-f3d78124968a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.facebook.com/stop2shop2",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496676915073679383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stop-2-shop",
      "poi_latitude": "30.2979261",
      "poi_longitude": "-89.7600459",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 985-259-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ25Xw2HmnYgRF4DWZu-LCWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_26f56cd2-c55f-4c63-86b9-b27c51bc4a2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Fremaux Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "55 Town Center Pkwy, Slidell, LA 70458, USA",
      "poi_short_description": "Shopping center featuring a variety of stores and eateries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-36f3-778b-8e38-adfa8a36d3e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-36f3-778b-8e38-adfa8a36d3e8",
        "storage_key": "property/6737460151191762/019e1e3d-36f3-778b-8e38-adfa8a36d3e8.webp",
        "width": 980,
        "height": 540
      },
      "poi_business_url": "http://fremauxtowncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15411449965780563945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fremaux-town-center",
      "poi_latitude": "30.2663031",
      "poi_longitude": "-89.7597706",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 985-898-2022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6YWWELnmnYgR6XcOLBd44NU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0a82454a-ea43-4698-b236-476e23a11204",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Whispering Forest Elementary",
      "poi_type": "Education",
      "poi_address": "38374 Spiehler Rd, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7f4b-769a-b29b-aa4d8f20936b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7f4b-769a-b29b-aa4d8f20936b",
        "storage_key": "property/6737460151191762/019e1e3f-7f4b-769a-b29b-aa4d8f20936b.webp",
        "width": 1030,
        "height": 687
      },
      "poi_business_url": "http://whisperingforestelementary.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2387263242320514034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whispering-forest-elementary",
      "poi_latitude": "30.319311",
      "poi_longitude": "-89.761888",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 985-641-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVxJZpGzmnYgR8ovcR0VDISE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9830a303-e0a4-485c-b54f-5722809e430b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Bonne Ecole Elementary School",
      "poi_type": "Education",
      "poi_address": "900 Rue Verand, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://bonneecoleelementary.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15108714921132603721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonne-ecole-elementary-school",
      "poi_latitude": "30.2896",
      "poi_longitude": "-89.76684",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 985-643-0674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd1LxjYXmnYgRSbnA3ivwrNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_69b252f8-e624-4746-856d-875a30c16d33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Bayou Woods Elementary School",
      "poi_type": "Education",
      "poi_address": "35614 Liberty Dr, Slidell, LA 70460, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-832c-77b8-b9d5-fc9cafcd13ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-832c-77b8-b9d5-fc9cafcd13ed",
        "storage_key": "property/6737460151191762/019e1e3f-832c-77b8-b9d5-fc9cafcd13ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bayouwoodselementary.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4308662254432693698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayou-woods-elementary-school",
      "poi_latitude": "30.28705",
      "poi_longitude": "-89.80703",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-641-1901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0-qjFDknYgRwi2Y_H1xyzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10e4a951-8f50-4092-98fa-3fe475730e7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Junior High",
      "poi_type": "Education",
      "poi_address": "333 Pennsylvania Ave, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://slidelljunior.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16473967135400361317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-junior-high",
      "poi_latitude": "30.28023",
      "poi_longitude": "-89.77935",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-641-5914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJje-QySbknYgRZX3_qtNJn-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_da6384bb-b03c-4ed2-8717-68d6fea9d8c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell High School",
      "poi_type": "Education",
      "poi_address": "1 Tiger Dr, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-801d-76ee-a52e-2376fb5015ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-801d-76ee-a52e-2376fb5015ac",
        "storage_key": "property/6737460151191762/019e1e3f-801d-76ee-a52e-2376fb5015ac.webp",
        "width": 1280,
        "height": 687
      },
      "poi_business_url": "http://slidellhigh.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14164222077210561999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-high-school",
      "poi_latitude": "30.28649",
      "poi_longitude": "-89.77276",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 985-643-2992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH4mmLoPmnYgRz43hF-9skcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_837635ba-2ce5-4cee-8731-2ad38ca667ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Salmen High School",
      "poi_type": "Education",
      "poi_address": "300 Spartan Dr, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://salmenhigh.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=167477276288887907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salmen-high-school",
      "poi_latitude": "30.24785",
      "poi_longitude": "-89.79030999999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 985-643-7359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3cT0L_TjnYgRYywmCbL_UgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a81cb500-3bcb-43b0-98a3-bed822b8ab42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Northshore High School",
      "poi_type": "Education",
      "poi_address": "100 Panther Dr, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://northshorehigh.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12379074210880371037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northshore-high-school",
      "poi_latitude": "30.2713963",
      "poi_longitude": "-89.743162",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-649-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmRRULNzmnYgRXTm5W2hOy6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_56eefcfd-d1b5-4c63-aeb1-297df063226a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Pope John Paul II Catholic High School",
      "poi_type": "Education",
      "poi_address": "1901 Jaguar Dr, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pjp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1621629701496094178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pope-john-paul-ii-catholic-high-school",
      "poi_latitude": "30.279686",
      "poi_longitude": "-89.743992",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 985-649-0914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY6E8g-bmnYgR4r3lKp8vgRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2a36fdd4-2178-4478-bd56-72af96fe04b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Delta College Slidell",
      "poi_type": "Education",
      "poi_address": "105 Gause Blvd W, Slidell, LA 70460, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-80ea-735c-bd06-60569af33fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-80ea-735c-bd06-60569af33fd2",
        "storage_key": "property/6737460151191762/019e1e3f-80ea-735c-bd06-60569af33fd2.webp",
        "width": 376,
        "height": 250
      },
      "poi_business_url": "https://www.deltacollege.com/locations/slidell",
      "poi_directions_map_url": "https://maps.google.com/?cid=6680218747739577507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delta-college-slidell",
      "poi_latitude": "30.2860142",
      "poi_longitude": "-89.78045739999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-643-7730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnZWMhkvknYgRoxzsyI7ntFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_b500eda9-016a-46f2-b2e9-d6d7fdfe09e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Primary Colors Learning Center",
      "poi_type": "Education",
      "poi_address": "1980 Rosemeade Dr, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://primarycolorspreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11405176907822517285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primary-colors-learning-center",
      "poi_latitude": "30.2817841",
      "poi_longitude": "-89.7371579",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-643-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrY1AkR3nnYgRJcw_b_hTR54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d8850f31-7848-4ff6-a832-edf86efb397b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "The Grand Slidell By Santikos",
      "poi_type": "Entertainment",
      "poi_address": "1950 Gause Blvd W, Slidell, LA 70460, USA",
      "poi_short_description": "Modern movie theater featuring reclining leather seats, 3D movies and an IMAX screen.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-82bf-7597-aff3-4040f921a75a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-82bf-7597-aff3-4040f921a75a",
        "storage_key": "property/6737460151191762/019e1e3f-82bf-7597-aff3-4040f921a75a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/slidell/the-grand-slidell/theater-info",
      "poi_directions_map_url": "https://maps.google.com/?cid=2098899586998326408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-grand-slidell-by-santikos",
      "poi_latitude": "30.30043349999999",
      "poi_longitude": "-89.8099603",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4d3-74c3-9deb-c0b3d32c4ad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4d3-74c3-9deb-c0b3d32c4ad5",
        "storage_key": "property/6737460151191762/019e1e3f-a4d3-74c3-9deb-c0b3d32c4ad5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJD1Sap6vlnYgRiNQ_zg3KIB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_91927ac8-15a7-4c51-871c-4ba0e867e29d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Little Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2024 Nellie Dr, Slidell, LA 70458, USA",
      "poi_short_description": "Local theater presenting 6 plays & musicals per season, including productions for kids.",
      "poi_long_description": "Local theater presenting 6 plays & musicals per season, including productions for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-81af-763b-8ec9-45c31094740a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-81af-763b-8ec9-45c31094740a",
        "storage_key": "property/6737460151191762/019e1e3f-81af-763b-8ec9-45c31094740a.webp",
        "width": 1178,
        "height": 884
      },
      "poi_business_url": "http://www.slidelllittletheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871676129208805620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-little-theatre",
      "poi_latitude": "30.2706708",
      "poi_longitude": "-89.7606966",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 985-643-0556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfDSgL7mnYgR9KglYKXOYs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_41204c1c-a500-4941-af2a-d14e8dfd0401",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "The Harbor Center",
      "poi_type": "Entertainment",
      "poi_address": "100 Harbor Center Blvd, Slidell, LA 70461, USA",
      "poi_short_description": "Convention center hosting events, including food-truck festivals, and competitions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-8827-74ac-bf99-1f9bda2813ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-8827-74ac-bf99-1f9bda2813ca",
        "storage_key": "property/6737460151191762/019e1e3f-8827-74ac-bf99-1f9bda2813ca.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://harborcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8048179363135419039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-harbor-center",
      "poi_latitude": "30.2179872",
      "poi_longitude": "-89.77179629999999",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 985-781-3650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv29namPhnYgRn_JQXH3gsG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_c8b71417-68fe-45fb-8725-9fa3ae3b1fd7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Museum",
      "poi_type": "Entertainment",
      "poi_address": "2020 1st St, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-3fc7-701f-b2bf-8d891fda6bb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-3fc7-701f-b2bf-8d891fda6bb9",
        "storage_key": "property/6737460151191762/019e1e3d-3fc7-701f-b2bf-8d891fda6bb9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myslidell.com/departments/cultural-public-affairs/slidell-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7220544155178756337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-museum",
      "poi_latitude": "30.2758179",
      "poi_longitude": "-89.7824626",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-646-4380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e1-7191-a7c2-c78c83c92a11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e1-7191-a7c2-c78c83c92a11",
        "storage_key": "property/6737460151191762/019e1e3d-66e1-7191-a7c2-c78c83c92a11.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9sFXyLknYgR8ehzLqeGNGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d52d99ca-2c29-4508-ac23-77653dfa4f11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Entertainment",
      "poi_address": "1701 Bayou Ln, Slidell, LA 70458, USA",
      "poi_short_description": "Green space featuring a playground & splash pad, plus picnic shelters, a boat launch & walking path.",
      "poi_long_description": "Green space featuring a playground & splash pad, plus picnic shelters, a boat launch & walking path.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-54e4-701c-a89e-06a279895bc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-54e4-701c-a89e-06a279895bc3",
        "storage_key": "property/6737460151191762/019e1e3d-54e4-701c-a89e-06a279895bc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4380245530380567713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "30.2779821",
      "poi_longitude": "-89.7839506",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-646-4371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0LeGCPknYgRoYRTMxrCyTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01a0d91f-c6bd-4f70-9c27-d06088e0960e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Times Grill",
      "poi_type": "Entertainment",
      "poi_address": "1827 Front St, Slidell, LA 70458, USA",
      "poi_short_description": "One of a family-friendly chain supplying burgers with specialty toppings in a brick-lined space.",
      "poi_long_description": "One of a family-friendly chain supplying burgers with specialty toppings in a brick-lined space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-792f-7384-b465-d80ed08c0d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-792f-7384-b465-d80ed08c0d7c",
        "storage_key": "property/6737460151191762/019e1e3f-792f-7384-b465-d80ed08c0d7c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://timesgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11937781495503996680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "times-grill",
      "poi_latitude": "30.278663",
      "poi_longitude": "-89.78244",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 985-639-3335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XSdoCPknYgRCEe_ZQWFq6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_8f68b27f-71f9-42d5-8f22-ee16ab9c0d66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Municipal Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "2056 2nd St, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-87d2-71eb-a2b0-8f2f38ec0344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-87d2-71eb-a2b0-8f2f38ec0344",
        "storage_key": "property/6737460151191762/019e1e3f-87d2-71eb-a2b0-8f2f38ec0344.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://myslidell.com/departments/public-operations/slidell-auditorium/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10514068092585056958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-municipal-auditorium",
      "poi_latitude": "30.2755113",
      "poi_longitude": "-89.7813402",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-646-4369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66b0-7188-8aad-07c4d24584db",
        "storage_key": "property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6S3QSLknYgRvhrNajl56ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_d472a96c-397a-4f93-b272-c46f3d6c3ca2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Gallagher's on Front Street",
      "poi_type": "Entertainment",
      "poi_address": "2306 Front St, Slidell, LA 70458, USA",
      "poi_short_description": "Cowboy ribeye, crispy redfish, and other steakhouse fare offered in a hip setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-88b0-7260-93db-ff171e485ef6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-88b0-7260-93db-ff171e485ef6",
        "storage_key": "property/6737460151191762/019e1e3f-88b0-7260-93db-ff171e485ef6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://gallaghersfrontstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=614058888167475544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallaghers-on-front-street",
      "poi_latitude": "30.2719184",
      "poi_longitude": "-89.78509129999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 985-326-8350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6696-7754-b914-2bbabeb52ddd",
        "storage_key": "property/6737460151191762/019e1e3d-6696-7754-b914-2bbabeb52ddd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_cx6fnlnYgRWMlkLE6ThQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_50ad25eb-b999-46d4-b3ff-9c8fc7bdcf5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1001 Gause Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-4cb7-76ad-8975-9270832a3e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-4cb7-76ad-8975-9270832a3e66",
        "storage_key": "property/6737460151191762/019e1e3d-4cb7-76ad-8975-9270832a3e66.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "http://www.slidellmemorial.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6264151857287218518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-memorial-hospital",
      "poi_latitude": "30.2838036",
      "poi_longitude": "-89.7702997",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 985-280-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6691-7681-bc0e-207c1bc5fa30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6691-7681-bc0e-207c1bc5fa30",
        "storage_key": "property/6737460151191762/019e1e3d-6691-7681-bc0e-207c1bc5fa30.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJu88qE5vmnYgRVkW14Oy87lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_103b512a-2cc6-4bf1-9d73-b187d995ff7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "SouthStar Urgent Care - Slidell",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 Pontchartrain Dr, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-88a9-717e-aaaa-c240da055212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-88a9-717e-aaaa-c240da055212",
        "storage_key": "property/6737460151191762/019e1e3f-88a9-717e-aaaa-c240da055212.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://gosouthstar.com/find-a-clinic/slidell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7121661410613303172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southstar-urgent-care---slidell",
      "poi_latitude": "30.258214",
      "poi_longitude": "-89.78802499999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-238-0320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WosTpLlnYgRhJc2HlI51WI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f54c5702-2ef8-423d-9f55-2af4e6673c2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Pelican Urgent Care & Occupational Health - Gause Slidell",
      "poi_type": "Health and Wellness",
      "poi_address": "2375 Gause Blvd E, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-8a77-760a-96c3-1936af01bb52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-8a77-760a-96c3-1936af01bb52",
        "storage_key": "property/6737460151191762/019e1e3f-8a77-760a-96c3-1936af01bb52.webp",
        "width": 1025,
        "height": 571
      },
      "poi_business_url": "https://pelicanurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4429751518645939482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pelican-urgent-care--occupational-health---gause-slidell",
      "poi_latitude": "30.289564",
      "poi_longitude": "-89.72509099999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 985-645-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3xV6w7nnYgRGm0jUImjeT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a67539b4-2d65-411e-b6a0-4c757e06c0a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4142 Pontchartrain Dr Walgreens, Slidell, LA 70458, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-7c64-7603-a5d0-53b49fc06626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-7c64-7603-a5d0-53b49fc06626",
        "storage_key": "property/6737460151191762/019e1e3f-7c64-7603-a5d0-53b49fc06626.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4142+pontchartrain+dr-slidell-la-70458/id=4285",
      "poi_directions_map_url": "https://maps.google.com/?cid=2386581460642408305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.2471518",
      "poi_longitude": "-89.7932307",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 985-649-3490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4UVocvXjnYgRcacfnTHXHiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ac6c1d6e-ddb2-4eb8-8f61-29d5fc547b48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Esporta Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "390 Town Center Pkwy, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-8b46-764a-9366-0c94aef7a807.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-8b46-764a-9366-0c94aef7a807",
        "storage_key": "property/6737460151191762/019e1e3f-8b46-764a-9366-0c94aef7a807.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.esportafitness.com/Pages/clubhome.aspx?clubid=1142&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8601959769630473378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "esporta-fitness",
      "poi_latitude": "30.2642989",
      "poi_longitude": "-89.7606963",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 985-718-3095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbduuL7mnYgRonwG2dVMYHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5dadcad5-b7d1-4d30-aef0-791efd448e37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Anytime Fitness Slidell",
      "poi_type": "Health and Wellness",
      "poi_address": "544 Robert Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Chain health club offering state-of-the-art equipment and personal training, open 24/7.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-510f-70ae-bbff-9bbf40e6f0e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-510f-70ae-bbff-9bbf40e6f0e2",
        "storage_key": "property/6737460151191762/019e1e3d-510f-70ae-bbff-9bbf40e6f0e2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.anytimefitness.com/gyms/4842/slidell-la-70458/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5644496548575991113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness-slidell",
      "poi_latitude": "30.2984348",
      "poi_longitude": "-89.7584866",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 985-288-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ225j9lvnnYgRSVXKgbRHVU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7c386e58-7444-415e-9c9a-9799038cc0f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Blue Arrow Yoga & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "224 Fremaux Ave, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-8c14-73cb-8f43-a148ffb11c96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-8c14-73cb-8f43-a148ffb11c96",
        "storage_key": "property/6737460151191762/019e1e3f-8c14-73cb-8f43-a148ffb11c96.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2629184141252408469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-arrow-yoga--spa",
      "poi_latitude": "30.27770799999999",
      "poi_longitude": "-89.781166",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-399-3701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ztnhw_lnYgRlbRw5Au9fCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f9b76869-9413-4072-8073-bc0b990d5461",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "The Pointe Marina of Slidell",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "118A Harbor View Ct, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-8e23-7528-bb9d-023b265f6b0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-8e23-7528-bb9d-023b265f6b0c",
        "storage_key": "property/6737460151191762/019e1e3f-8e23-7528-bb9d-023b265f6b0c.webp",
        "width": 1280,
        "height": 512
      },
      "poi_business_url": "http://www.thepointeslidell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15594153029017912954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pointe-marina-of-slidell",
      "poi_latitude": "30.2169309",
      "poi_longitude": "-89.7984889",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 985-288-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwBr-7njnYgResax-46Padg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "marina"
    },
    {
      "id": "custom_949e8891-ddaa-494e-ba61-bdc862ca9faf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Fritchie Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "905 W Howze Beach Rd, Slidell, LA 70458, USA",
      "poi_short_description": "Tree-filled space with baseball & softball diamonds, plus trails, a playground & a pavilion.",
      "poi_long_description": "Tree-filled space with baseball & softball diamonds, plus trails, a playground & a pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-5a70-76c0-89fd-963fbce337fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-5a70-76c0-89fd-963fbce337fb",
        "storage_key": "property/6737460151191762/019e1e3d-5a70-76c0-89fd-963fbce337fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myslidell.com/departments/parks-and-recreation/discover-our-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9437680488560837218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fritchie-park",
      "poi_latitude": "30.2459634",
      "poi_longitude": "-89.7728128",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 985-646-4371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_4ExX_mnYgRYsJNwGZg-YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c88e9f55-5aa0-4acf-94b3-8633e7207a11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "John Slidell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 Robert Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Wooded site with a 1.5-mi. trail & ball fields, plus a playground, an indoor gym & picnic pavilion.",
      "poi_long_description": "Wooded site with a 1.5-mi. trail & ball fields, plus a playground, an indoor gym & picnic pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-52a4-7489-9c81-587a4c09aaa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-52a4-7489-9c81-587a4c09aaa2",
        "storage_key": "property/6737460151191762/019e1e3d-52a4-7489-9c81-587a4c09aaa2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://myslidell.com/departments/parks-and-recreation/discover-our-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6079656052427094091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-slidell-park",
      "poi_latitude": "30.3061879",
      "poi_longitude": "-89.7470903",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 985-646-4371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWalHulvmnYgRS3h44fdGX1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2635e1ed-46d1-4d2a-89e4-128f75ee7458",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "St. Tammany Trace Parish Paved Bike Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2289 Gause Blvd W, Slidell, LA 70460, USA",
      "poi_short_description": "Paved, car-free path offering various outdoor activities such as walking, running, biking and inline skating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-9067-744f-90ce-42c0bc2b8324.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-9067-744f-90ce-42c0bc2b8324",
        "storage_key": "property/6737460151191762/019e1e3f-9067-744f-90ce-42c0bc2b8324.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://tammanytrace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11705836023819273036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-tammany-trace-parish-paved-bike-trailhead",
      "poi_latitude": "30.3014483",
      "poi_longitude": "-89.83146149999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 985-781-1229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cTj6yHlnYgRTAO47td7c6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_8f0d0bfe-f6a4-4ddf-8486-398c7257c865",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Camp Salmen Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "35122 Parish Pkwy, Slidell, LA 70460, USA",
      "poi_short_description": "Wooded park with a playground & walking trails, plus 3 pavilions & an amphitheater for events.",
      "poi_long_description": "Wooded park with a playground & walking trails, plus 3 pavilions & an amphitheater for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-54db-7749-8bbe-f7fbde611aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-54db-7749-8bbe-f7fbde611aaa",
        "storage_key": "property/6737460151191762/019e1e3d-54db-7749-8bbe-f7fbde611aaa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.campsalmennaturepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12069549721169906845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camp-salmen-nature-park",
      "poi_latitude": "30.2943429",
      "poi_longitude": "-89.8180531",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawvhLuPknYgRnUw_MYanf6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d022dbbf-6631-4dc2-884a-e1eaac41d73c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Bayou Lacombe Visitor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lacombe, LA 70445, USA",
      "poi_short_description": "Trails, exhibits and classes about the region's wildlife at a refuge.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-96aa-77da-80bd-440a99b70945.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-96aa-77da-80bd-440a99b70945",
        "storage_key": "property/6737460151191762/019e1e3f-96aa-77da-80bd-440a99b70945.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fws.gov/media/bayou-lacombe-visitor-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1175102855136958357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayou-lacombe-visitor-center",
      "poi_latitude": "30.3214187",
      "poi_longitude": "-89.93805929999999",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQX8jx-z5nYgRlVf8HtLNThA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_f46b30c4-71ff-4a20-8821-d6ef1efa7687",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Possum Hollow Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "801 Cousin St, Slidell, LA 70458, USA",
      "poi_short_description": "Tree-lined green space with 2 softball fields, 2 multi-use fields & a rentable picnic pavilion.",
      "poi_long_description": "Tree-lined green space with 2 softball fields, 2 multi-use fields & a rentable picnic pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-90d7-70fa-b813-11a1e8e802f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-90d7-70fa-b813-11a1e8e802f9",
        "storage_key": "property/6737460151191762/019e1e3f-90d7-70fa-b813-11a1e8e802f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myslidell.com/departments/parks-and-recreation/discover-our-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15766120688661508067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "possum-hollow-park",
      "poi_latitude": "30.2729944",
      "poi_longitude": "-89.7769438",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-646-4371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwelBJyDknYgR4y-b3TuDzNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_68be5bea-7343-4921-bca8-35870e14bb0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Rufus Viner Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1010 Schley St, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://myslidell.com/departments/parks-and-recreation/discover-our-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13746182478629977218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rufus-viner-park",
      "poi_latitude": "30.2711354",
      "poi_longitude": "-89.77605249999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 985-646-4369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66cf-738c-a0ec-1523e9f3cde5",
        "storage_key": "property/6737460151191762/019e1e3d-66cf-738c-a0ec-1523e9f3cde5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZlyLR7knYgRgjxwSCJAxL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f26ed6a2-330b-4ab6-af5e-caeb12af8be8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Carollo Trailhead Park and Ride (Thompson Rd)",
      "poi_type": "Transportation & Transit",
      "poi_address": "2289 Hwy 190 W, Slidell, LA 70460, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-93fc-7139-8d2e-3c2a077f68fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-93fc-7139-8d2e-3c2a077f68fb",
        "storage_key": "property/6737460151191762/019e1e3f-93fc-7139-8d2e-3c2a077f68fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4498951849980152841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carollo-trailhead-park-and-ride-thompson-rd",
      "poi_latitude": "30.3014254",
      "poi_longitude": "-89.8314848",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUaq5OLlnYgRCUyn_958bz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_735e4232-6990-4d40-82f8-115fc75ba489",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Fremaux Quick Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15434507243511711939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-fremaux-quick-stop",
      "poi_latitude": "30.27749399999999",
      "poi_longitude": "-89.775802",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP86MgyDknYgRw4i1_I9iMtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_fec39ba0-96fe-4932-9ffa-b03eea10a4d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "North Boulevard Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "393 North Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12102753336155581182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-boulevard-park-and-ride",
      "poi_latitude": "30.2988487",
      "poi_longitude": "-89.7622485",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4d0-7388-87f1-b6a0ece683b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4d0-7388-87f1-b6a0ece683b1",
        "storage_key": "property/6737460151191762/019e1e3f-a4d0-7388-87f1-b6a0ece683b1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUYBw7DnnYgR_iq6PQme9ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_708affe7-7d09-41fa-b4d4-3f79341fa2e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell, LA",
      "poi_type": "Transportation & Transit",
      "poi_address": "1827 Front St, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-5c4d-73fd-8606-37d535ef80dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-5c4d-73fd-8606-37d535ef80dd",
        "storage_key": "property/6737460151191762/019e1e3d-5c4d-73fd-8606-37d535ef80dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SDL",
      "poi_directions_map_url": "https://maps.google.com/?cid=13800117768351198540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-la",
      "poi_latitude": "30.27837",
      "poi_longitude": "-89.78256999999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-696d-74fa-98b0-0208ad57d9d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-696d-74fa-98b0-0208ad57d9d1",
        "storage_key": "property/6737460151191762/019e1e3d-696d-74fa-98b0-0208ad57d9d1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XSdoCPknYgRTC0hgf7dg78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_09f7d65f-6528-4426-9b9b-52afdab845ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Oak Harbor Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Harbor Center Blvd, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14239343571994375763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-harbor-park-and-ride",
      "poi_latitude": "30.2165966",
      "poi_longitude": "-89.77387069999999",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-a4d0-7388-87f1-b6a0ece683b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3f-a4d0-7388-87f1-b6a0ece683b1",
        "storage_key": "property/6737460151191762/019e1e3f-a4d0-7388-87f1-b6a0ece683b1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcMTMV_hnYgRU3Z3E4lPnMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_d179e0e6-61cf-4053-bdad-01420118a69d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "TA Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1682 Gause Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Truck stop featuring a driver's lounge, showers, a restaurant, and 139 parking spaces, plus a convenience store.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-912a-71ee-977b-95351ae542eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-912a-71ee-977b-95351ae542eb",
        "storage_key": "property/6737460151191762/019e1e3f-912a-71ee-977b-95351ae542eb.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.ta-petro.com/location/la/ta-slidell",
      "poi_directions_map_url": "https://maps.google.com/?cid=12725791554443041247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ta-travel-center",
      "poi_latitude": "30.2862967",
      "poi_longitude": "-89.7510561",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 985-643-9974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4aKb6PHmnYgR31k-oP4Xm7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_e9bc7572-5875-4aac-8733-1e92e9776e44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Circle K | Truck Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "368 Voters Rd, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.circlek.com/store-locator/US/slidell/368-voters-rd/2721594?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9813111392871756456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k--truck-stop",
      "poi_latitude": "30.24690799999999",
      "poi_longitude": "-89.761128",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-276-1947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqTT-KGjhnYgRqLJ12dEsL4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_db118b9f-8651-45fd-b666-e8648ba2df77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Municipal Airport KASD",
      "poi_type": "Transportation & Transit",
      "poi_address": "62512 Airport Rd, Slidell, LA 70460, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-555f-7718-9584-4fd47f91d99a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-555f-7718-9584-4fd47f91d99a",
        "storage_key": "property/6737460151191762/019e1e3d-555f-7718-9584-4fd47f91d99a.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10857915947236400016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-municipal-airport-kasd",
      "poi_latitude": "30.3424857",
      "poi_longitude": "-89.8231007",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 985-641-7590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66de-7172-a14d-98bf1790745b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66de-7172-a14d-98bf1790745b",
        "storage_key": "property/6737460151191762/019e1e3d-66de-7172-a14d-98bf1790745b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_So4IfvnYgRkBsTvAYRr5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e3de25a0-627f-4aa7-af8a-0a4dc5c86fe8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Ochsner Health Center - Slidell Campus Building 2",
      "poi_type": "Major Employers & Offices",
      "poi_address": "105 Medical Center Dr STE 202, Slidell, LA 70461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-963f-70d8-81e8-8ae958cc3070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-963f-70d8-81e8-8ae958cc3070",
        "storage_key": "property/6737460151191762/019e1e3f-963f-70d8-81e8-8ae958cc3070.webp",
        "width": 930,
        "height": 523
      },
      "poi_business_url": "http://digital.ochsner.org/schedule-now-nse?utm_source=YextGoogle&utm_medium=Yext&y_source=1_MTUyMDE3ODctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13047710921836767994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ochsner-health-center---slidell-campus-building-2",
      "poi_latitude": "30.2868666",
      "poi_longitude": "-89.7443748",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-639-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwKsPfvmnYgR-qoQJPTHErU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_68dc6714-81b3-40ac-a03b-17ddc5d53704",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "St. Tammany Parish Government",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21490 Koop Dr, Mandeville, LA 70471, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-977d-760e-b6f0-1e04e0d22cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-977d-760e-b6f0-1e04e0d22cb6",
        "storage_key": "property/6737460151191762/019e1e3f-977d-760e-b6f0-1e04e0d22cb6.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "http://www.stpgov.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4959026750208194133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-tammany-parish-government",
      "poi_latitude": "30.4176841",
      "poi_longitude": "-90.0421489",
      "poi_miles_from_property": "25.6",
      "poi_walking_minutes": "9 hours 19 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 985-898-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66b0-7188-8aad-07c4d24584db",
        "storage_key": "property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZhhWCFZJ4YRVbbRJY4A0kQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_6df4fdfc-24f5-4567-b99b-fdcc4e6c8b06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "St Tammany Parish Public School System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "321 N Theard St, Covington, LA 70433, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stpsb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10220205626930794467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-tammany-parish-public-school-system",
      "poi_latitude": "30.477121",
      "poi_longitude": "-90.09881",
      "poi_miles_from_property": "29.5",
      "poi_walking_minutes": "10 hours 39 mins",
      "poi_biking_minutes": "2 hours 51 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 985-892-2276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYdxZUFBcJ4YR44-oZN521Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0a66b6f7-1f6f-4d23-8556-9db4d13da5d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "St. Tammany Parish Justice Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 N Columbia St, Covington, LA 70433, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-9960-712a-9059-10ffb209973e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-9960-712a-9059-10ffb209973e",
        "storage_key": "property/6737460151191762/019e1e3f-9960-712a-9059-10ffb209973e.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://22ndjdc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8200678588848664106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-tammany-parish-justice-center",
      "poi_latitude": "30.4802794",
      "poi_longitude": "-90.0963631",
      "poi_miles_from_property": "29.6",
      "poi_walking_minutes": "10 hours 41 mins",
      "poi_biking_minutes": "2 hours 52 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66b0-7188-8aad-07c4d24584db",
        "storage_key": "property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSFEGEtcJ4YRKu55PbqpznE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_99361cb8-fc0f-4e03-abeb-16caa89a5a6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "St. Tammany Parish Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1202 S Tyler St, Covington, LA 70433, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-9980-7657-9080-750b32d39cc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-9980-7657-9080-750b32d39cc6",
        "storage_key": "property/6737460151191762/019e1e3f-9980-7657-9080-750b32d39cc6.webp",
        "width": 749,
        "height": 369
      },
      "poi_business_url": "https://www.sttammany.health/HospitalServices?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1467257646305575394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-tammany-parish-hospital",
      "poi_latitude": "30.468998",
      "poi_longitude": "-90.1130219",
      "poi_miles_from_property": "30.7",
      "poi_walking_minutes": "11 hours 6 mins",
      "poi_biking_minutes": "2 hours 58 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 985-898-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6691-7681-bc0e-207c1bc5fa30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6691-7681-bc0e-207c1bc5fa30",
        "storage_key": "property/6737460151191762/019e1e3d-6691-7681-bc0e-207c1bc5fa30.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqT-_sPdcJ4YR4gEFMg6_XBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_5fb3bb0b-4a43-4e2a-bd77-d33a4668b28e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Lakeview Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "95 Judge Tanner Blvd, Covington, LA 70433, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-9c8f-76e3-82e3-5943d363c9c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-9c8f-76e3-82e3-5943d363c9c7",
        "storage_key": "property/6737460151191762/019e1e3f-9c8f-76e3-82e3-5943d363c9c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lcmchealth.org/lakeview-hospital/?utm_source=GMB&utm_medium=Yext&y_source=1_NzM3ODcyMzktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14116993495569137074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeview-hospital",
      "poi_latitude": "30.4110744",
      "poi_longitude": "-90.0807189",
      "poi_miles_from_property": "26",
      "poi_walking_minutes": "9 hours 27 mins",
      "poi_biking_minutes": "2 hours 23 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 985-867-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6691-7681-bc0e-207c1bc5fa30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6691-7681-bc0e-207c1bc5fa30",
        "storage_key": "property/6737460151191762/019e1e3d-6691-7681-bc0e-207c1bc5fa30.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMx2f979bJ4YRsv3lB8qi6cM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_86310369-d4e6-4dfa-b126-a9d5900a0a0e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Northshore Technical Community College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "65556 Centerpoint Blvd, Lacombe, LA 70445, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-9b03-7394-abd3-346f2cdc9fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-9b03-7394-abd3-346f2cdc9fe3",
        "storage_key": "property/6737460151191762/019e1e3f-9b03-7394-abd3-346f2cdc9fe3.webp",
        "width": 604,
        "height": 340
      },
      "poi_business_url": "http://northshorecollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7911629037456886430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northshore-technical-community-college",
      "poi_latitude": "30.379083",
      "poi_longitude": "-89.8992076",
      "poi_miles_from_property": "14.3",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 985-545-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66e7-7557-8554-776d937d56b6",
        "storage_key": "property/6737460151191762/019e1e3d-66e7-7557-8554-776d937d56b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ56-q_eTwnYgRnopIJLHAy20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0d0ec5c5-71ff-473b-be40-aa42961ddaa7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2055 2nd St, Slidell, LA 70458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6056-7387-935a-edbea1b049c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6056-7387-935a-edbea1b049c5",
        "storage_key": "property/6737460151191762/019e1e3d-6056-7387-935a-edbea1b049c5.webp",
        "width": 798,
        "height": 1280
      },
      "poi_business_url": "http://myslidell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5265592232335563014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slidell-city-hall",
      "poi_latitude": "30.275462",
      "poi_longitude": "-89.7818376",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 985-646-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66b0-7188-8aad-07c4d24584db",
        "storage_key": "property/6737460151191762/019e1e3d-66b0-7188-8aad-07c4d24584db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0FKaiLknYgRBtlqrDwkE0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_6b88cd0c-5654-4e53-97de-f094b7f73f19",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "167 Northshore Blvd, Slidell, LA 70460, USA",
      "poi_short_description": "Chain retailer offering groceries, electronics, home goods, clothing, toys and other merchandise.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3f-9f9a-7229-bd25-637c91049c66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3f-9f9a-7229-bd25-637c91049c66",
        "storage_key": "property/6737460151191762/019e1e3f-9f9a-7229-bd25-637c91049c66.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2665-slidell-la/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1488777981536527989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.3082237",
      "poi_longitude": "-89.8286361",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 985-690-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy70athvlnYgRdWbosq8zqRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8d998021-bc9a-4072-a539-46c6b3f41d92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Slidell Midtown Square Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1326 Corporate Square Dr, Slidell, LA 70458, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors appreciate this shopping center for its wide selection of stores, which includes seasonal items, crafts, and tools, along with the convenience of ample parking. The helpful staff and consistently clean environment are also frequently mentioned as positive aspects.\n\nSome reviews mention the service can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019ea8ef-992a-70bf-a2d3-db6aad18135e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ef-992a-70bf-a2d3-db6aad18135e",
        "storage_key": "property/6737460151191762/019ea8ef-992a-70bf-a2d3-db6aad18135e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://laretail.com/properties/midtown-square-shopping-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6430068470467429964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "slidell-midtown-square-shopping-center",
      "poi_latitude": "30.2830704",
      "poi_longitude": "-89.75551589999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 504-733-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRds4H-3mnYgRTIamtzQxPFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6ac50c6a-b579-43b2-a603-50eb889e514a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "181 Northshore Blvd, Slidell, LA 70460, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Customers consistently praise this store for its wide variety of fresh foods, merchandise, and bulk items available at good prices, along with the convenience of their scan-and-go app. They also appreciate the clean environment and highlight the cafe's amazing pizza and affordable combos, as well as the friendly staff.\n\nSome reviews mention the service can be inefficient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019ea8ef-95ca-740b-8d14-751f546a0d33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ef-95ca-740b-8d14-751f546a0d33",
        "storage_key": "property/6737460151191762/019ea8ef-95ca-740b-8d14-751f546a0d33.webp",
        "width": 1050,
        "height": 697
      },
      "poi_business_url": "https://www.samsclub.com/club/6220-slidell-la",
      "poi_directions_map_url": "https://maps.google.com/?cid=10832718808365637802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "30.3100232",
      "poi_longitude": "-89.8286473",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 985-641-1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-66d1-747a-869e-afbc023f75f9",
        "storage_key": "property/6737460151191762/019e1e3d-66d1-747a-869e-afbc023f75f9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLbiqDg_jnYgRqqBTrFyMVZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_8d11b018-2112-4bd5-bf60-08a6c61363a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Bowling USA",
      "poi_type": "Entertainment",
      "poi_address": "685 Brownswitch Rd, Slidell, LA 70458, USA",
      "poi_short_description": "Bowling alley with an arcade, a kid-friendly environment, and a positive atmosphere.",
      "poi_long_description": "Some people say this bowling alley has a fun arcade.\n\nOther reviews mention it can be outdated and expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019ea8ef-9989-75a7-ac21-70a84e74e628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ef-9989-75a7-ac21-70a84e74e628",
        "storage_key": "property/6737460151191762/019ea8ef-9989-75a7-ac21-70a84e74e628.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bowlingusa.top/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6456999256591797497&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bowling-usa",
      "poi_latitude": "30.3099385",
      "poi_longitude": "-89.7510119",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 985-649-4811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgbH96kTmnYgR-Ywd_Jzem1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_8e2f7eca-43b2-4db9-9465-701ddde651a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Altitude Trampoline Park Slidell",
      "poi_type": "Entertainment",
      "poi_address": "120 Northshore Blvd, Slidell, LA 70460, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this amusement center offers a variety of fun and unique activities for all ages, including trampolines, a trapeze, and a foam pit. They also highlight the friendly, attentive, and helpful staff, and the clean and safe environment.\n\nOther reviews mention the activities can be geared towards children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019ea8ef-9762-742d-8763-3548a7b35dbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ef-9762-742d-8763-3548a7b35dbd",
        "storage_key": "property/6737460151191762/019ea8ef-9762-742d-8763-3548a7b35dbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.altitudetrampolinepark.com/locations/louisiana/slidell/120-northshore-blvd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567140149968508242&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "altitude-trampoline-park-slidell",
      "poi_latitude": "30.3038544",
      "poi_longitude": "-89.824495",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 985-649-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15a0BJblnYgRUhWEd11QoCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_0798ef61-87c4-49be-a8ba-61d52482bcd6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Hollywood Casino & Resort Gulf Coast",
      "poi_type": "Entertainment",
      "poi_address": "711 Hollywood Blvd, Bay St Louis, MS 39520, USA",
      "poi_short_description": "Casino hotel with modern rooms, a lazy river & pool, plus an Arnold Palmer-designed golf course.",
      "poi_long_description": "People say this casino offers a lazy river, pool, and hot tub, as well as a buffet and several restaurants. They also highlight the friendly staff, clean rooms, and fun atmosphere.\n\nSome reviews mention the rooms can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019ea8ef-95da-7435-83f4-d71e07ed9b0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ef-95da-7435-83f4-d71e07ed9b0c",
        "storage_key": "property/6737460151191762/019ea8ef-95da-7435-83f4-d71e07ed9b0c.webp",
        "width": 512,
        "height": 288
      },
      "poi_business_url": "https://www.hollywoodgulfcoast.com/?utm_source=google&utm_medium=organic&utm_campaign=localseo",
      "poi_directions_map_url": "https://maps.google.com/?cid=5898429045606019878&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hollywood-casino--resort-gulf-coast",
      "poi_latitude": "30.3347885",
      "poi_longitude": "-89.3537636",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 228-469-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwCueYQtnIgRJnMxPPdt21E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_9559cf1f-6b5f-41a2-80d1-74cb965a0849",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "poi_name": "Cutting Edge Center of the Arts | CECA | Cutting Edge Theater | Slidell, Louisiana",
      "poi_type": "Entertainment",
      "poi_address": "767 Robert Blvd, Slidell, LA 70458, USA",
      "poi_short_description": "Casual theater and salon featuring a mix of local productions, haircuts and color treatments.",
      "poi_long_description": "People say this theater offers professional-style shows with amazing local talent, featuring great adaptations and original productions. Visitors highlight the lovely theater seating, elevated stage, and professional sound and lighting. They also mention the exceptional cast and friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019ea8ef-9a4d-7110-85a6-d340e80c1b29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8ef-9a4d-7110-85a6-d340e80c1b29",
        "storage_key": "property/6737460151191762/019ea8ef-9a4d-7110-85a6-d340e80c1b29.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "http://www.cuttingedgetheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10405504165196545324&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cutting-edge-center-of-the-arts--ceca--cutting-edge-theater--slidell-louisiana",
      "poi_latitude": "30.2955841",
      "poi_longitude": "-89.76486729999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 985-649-3727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3d-6699-72f3-8949-e0f3208cb4e5",
        "storage_key": "property/6737460151191762/019e1e3d-6699-72f3-8949-e0f3208cb4e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5htR4jmnYgRLD1jU-jGZ5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    }
  ],
  "office_hours": [
    {
      "id": "custom_7fa2658c-ea1b-4880-a50e-31725fd1409b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c61ab328-9ff4-4a08-8549-708f0ce714b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_78818f29-f9b8-46fe-bf9e-377d068ba507",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a6cb31e0-8bd7-479a-98c6-3c23f0e54bc1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bbe48c29-2683-4827-b14a-154c64e3a732",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8bc57edd-b1d9-477e-bd62-48c15903836e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_32af88b1-fb0c-491f-9549-2807fd481eeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "rating": "5",
      "name": "Marcia Washington",
      "text": "Excellent Five Stars. I Believe I Was At Home Already Going To Call Her Ms. Roe Very Hospitable Yet Very Professional and Courteous. I Was Well At Ease The Entire Time. Looking Forward To Being A Tenant In The Future Thank You Marcia",
      "date": "2026-05-18",
      "title": "false"
    },
    {
      "id": "custom_2d027260-79a7-4745-87b9-667feb992326",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "rating": "5",
      "name": "Kareem Varnado",
      "text": "I would like to take a moment to recognize our supervisor, Crystal, for the outstanding job she has been doing. Since her arrival, she has truly been a breath of fresh air. She consistently demonstrates professionalism, courtesy, and a genuine commitment to excellence in her role.\n\nShe is always attentive to our needs and concerns regarding maintenance issues, ensuring that they are addressed promptly and effectively. What stands out most is her willingness to go above and beyond the call of duty to make sure we receive quality service. Her responsiveness, clear communication, and dedication have made a noticeable and positive impact on our experience.\n\nIt is refreshing to have someone who takes pride in their work and genuinely cares about the people they serve. Her leadership and work ethic set a strong example, and her presence is greatly appreciated. Thank you.",
      "date": "2026-04-22",
      "title": "false"
    },
    {
      "id": "custom_a6f84def-7168-4571-b0e9-fab6f8b3ed5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "rating": "5",
      "name": "naz",
      "text": "Lee, the maintenance technician, was very professional. He came in already knowing what the issue was and got straight to work without any delays. He fixed everything quickly and efficiently. He was respectful, and made the whole process smooth. Definitely appreciate the quick and reliable service.",
      "date": "2026-03-25",
      "title": "false"
    },
    {
      "id": "custom_03caa565-1c3f-4fb9-8a88-fac1a3370202",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "rating": "5",
      "name": "Krystal Lane",
      "text": "Rachel in the office is incredible and very informative, she was able to correct my lease and did it seamlessly. The office staff at Pelican is top tier an I would recommend this property without a doubt.",
      "date": "2026-04-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d0af625b-04a4-4dcd-b2c1-8bf5341a5506",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019e1e3d-2b24-77f6-8cfe-6e276d5285d6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e3d-2b24-77f6-8cfe-6e276d5285d6",
        "storage_key": "property/6737460151191762/019e1e3d-2b24-77f6-8cfe-6e276d5285d6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=66836cb5c5e71e10fda25545"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d3-ae22-74d3-b5ee-3d3bf11a0587",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Pelican Pointe property website",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762"
    },
    {
      "lead_collector_id": "019910d3-ae96-7377-ace0-bdd77d3a31df",
      "lead_source": "FACEBOOK_ADS",
      "name": "Pelican Pointe facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762"
    },
    {
      "lead_collector_id": "019910d3-af12-746f-b57e-9410702fe1cf",
      "lead_source": "LANDING_PAGE",
      "name": "Pelican Pointe landing page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-slidell-la",
      "search_query": "luxury apartments with pool in Slidell LA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Slidell, LA",
      "h2_subtitle": "Discover luxury living in Slidell, LA. Dive into our sparkling pool and experience the premium lifestyle you've been searching for.",
      "page_copy": "At Pelican Pointe in Slidell, LA, experience the best in luxury apartments with a pool that truly sets us apart. Our sparkling swimming pool is perfect for a refreshing dip on a warm day. Besides the pool, the comprehensive suite of amenities includes a modern fitness center and exquisite clubhouse, designed with your comfort in mind. Choose from our spacious one, two, or three-bedroom floor plans to suit your lifestyle.\n\nNestled in the thriving community of Slidell, Pelican Pointe offers more than just a place to live. Whether you're strolling along the serene walking trails or enjoying time with family at the playground, there's something here for everyone. Our pet-friendly environment ensures that all members of your family feel at home. Experience the fusion of luxury and convenience at Pelican Pointe, where each apartment is cable ready and features stunning granite countertops.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Slidell, LA",
      "seo_description": "Experience luxury living in Slidell, LA, with our sparkling pool and premium amenities at Pelican Pointe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-st-tammany-parish",
      "search_query": "fitness center apartments in St. Tammany Parish",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in St. Tammany Parish",
      "h2_subtitle": "Experience modern living with a fully-equipped fitness center in St. Tammany Parish. Discover a healthier lifestyle at Pelican Pointe.",
      "page_copy": "Welcome to Pelican Pointe, where you'll find premier fitness center apartments in the heart of St. Tammany Parish. Our state-of-the-art fitness center is designed to cater to all your exercise needs, whether you're looking to maintain your routine or start a new fitness journey. With a variety of equipment available, staying active has never been more convenient.\n\nSituated in the charming community of Outlying St. Tammany Parish, Pelican Pointe offers more than just fitness amenities. Our spacious one, two, and three-bedroom floor plans come with luxury features like granite countertops and a cable-ready setup. Enjoy the best of apartment living alongside other community conveniences such as a sparkling pool and serene walking trails. Experience the vibrant lifestyle at Pelican Pointe today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in St. Tammany Parish",
      "seo_description": "Live actively at Pelican Pointe with our top-notch fitness center in St. Tammany Parish. Explore luxury living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-with-walking-trails-slidell",
      "search_query": "pet friendly apartments with walking trails Slidell",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Walking Trails",
      "h2_subtitle": "Discover pet-friendly apartments in Slidell featuring scenic walking trails. Pelican Pointe welcomes you and your four-legged friends.",
      "page_copy": "Pelican Pointe offers pet-friendly apartments with walking trails, perfect for both you and your furry companions in Slidell. Enjoy serene walks along beautifully maintained trails just steps from your door, making daily strolls with your pet a delightful experience. Our community understands the bond between you and your pets, which is why we strive to create a welcoming environment for all.\n\nIn addition to our pet-friendly amenities, Pelican Pointe provides spacious one, two, and three-bedroom apartments equipped with luxury features such as granite countertops and a cable-ready setup. Relax by our sparkling pool or visit the clubhouse for community events. Nestled in the vibrant neighborhood of Slidell, you’ll find more than just a home; you’ll find a community that embraces an active, pet-friendly lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Walking Trails",
      "seo_description": "Pelican Pointe in Slidell offers pet-friendly living with walking trails. Enjoy a community designed for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-near-70458",
      "search_query": "apartments with in unit laundry near 70458",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Near 70458",
      "h2_subtitle": "Convenience meets luxury at Pelican Pointe near 70458. Discover apartments featuring in-unit laundry for a hassle-free lifestyle.",
      "page_copy": "Discover the blend of convenience and luxury at Pelican Pointe, where our apartments with in-unit laundry near 70458 offer the ultimate living experience. Streamline your daily chores with the comfort of having a washer and dryer at your fingertips. Our spacious one, two, and three-bedroom floor plans provide modern living spaces tailored to your lifestyle.\n\nLocated in the vibrant area of Slidell, Pelican Pointe goes beyond mere accommodation. Enjoy a range of upscale amenities, from the sparkling pool and serene walking trails to the fully-equipped fitness center. With cable-ready apartments and elegant granite countertops, we invite you to experience a seamless balance between comfort and style. Choose Pelican Pointe and make laundry day a breeze while enjoying all the conveniences this community has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Near 70458",
      "seo_description": "Experience convenience with in-unit laundry at Pelican Pointe near 70458. Explore superior living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-outlying-st-tammany-parish",
      "search_query": "apartments with air conditioning in Outlying St Tammany Parish",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in St Tammany Parish",
      "h2_subtitle": "Stay cool and comfortable in our air-conditioned apartments in Outlying St Tammany Parish. Pelican Pointe offers ultimate comfort.",
      "page_copy": "Escape the heat with the air-conditioned apartments at Pelican Pointe, situated in Outlying St Tammany Parish. Our community ensures that you remain comfortable year-round with modern, efficient air conditioning systems in all one, two, and three-bedroom units. Designed for comfort, each apartment offers a perfect retreat from the warm Louisiana weather.\n\nPelican Pointe not only provides the comfort of air-conditioned living but also enriches your lifestyle with a host of amenities. Relax by our sparkling pool, take your pet for a stroll on our walking trails, or socialize at the clubhouse. Located in a serene neighborhood yet easily accessible, our community combines tranquility with convenience. Experience the perfect mix of leisure and comfort at Pelican Pointe today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in St Tammany Parish",
      "seo_description": "Pelican Pointe in Outlying St Tammany Parish offers air-conditioned apartments ensuring ultimate comfort. Discover today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-slidell-la",
      "search_query": "two bedroom apartments Slidell LA",
      "category": "Floorplan",
      "h1_title": "Spacious Two-Bedroom Apartments in Slidell",
      "h2_subtitle": "Explore two-bedroom apartments in Slidell, LA at Pelican Pointe. Ideal for families or roommates, our homes offer modern comforts and amenities.",
      "page_copy": "Welcome to Pelican Pointe's spacious two-bedroom apartments in Slidell, LA, designed for comfort and style. Each of our two-bedroom units offers modern features, including granite countertops and in-unit laundry facilities. Perfect for families or roommates, these thoughtfully designed spaces provide flexibility and comfort in a vibrant community setting.\n\nLocated in the heart of Slidell, Pelican Pointe boasts a variety of luxury amenities, ensuring an elevated living experience. Enjoy leisurely afternoons by the sparkling pool, take advantage of our fully-equipped fitness center, or enjoy the scenic walking trails on our well-maintained grounds. With a pet-friendly policy and an engaging community atmosphere, Pelican Pointe offers more than just a place to live—it provides a dynamic lifestyle tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Slidell, LA",
      "seo_description": "Discover spacious two-bedroom apartments at Pelican Pointe in Slidell, LA. Modern amenities and a vibrant community await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-70458",
      "search_query": "one bedroom apartments near 70458",
      "category": "Floorplan",
      "h1_title": "Modern One-Bedroom Apartments Near 70458",
      "h2_subtitle": "Discover stylish one-bedroom apartments near 70458. Pelican Pointe offers the perfect blend of comfort and convenience in Slidell, LA.",
      "page_copy": "Find the perfect blend of comfort and convenience with our one-bedroom apartments near 70458 at Pelican Pointe. Our thoughtfully designed layouts offer ample living space, perfect for individuals or couples seeking a modern lifestyle. Each unit is fitted with quality finishes, including granite countertops and in-unit laundry, providing all the modern conveniences you need.\n\nLocated in Slidell, Pelican Pointe's one-bedroom apartments provide access to an array of amenities that enhance your living experience. Enjoy a refreshing swim in our sparkling pool or stay active in the state-of-the-art fitness center. The community's pet-friendly atmosphere, combined with beautiful walking trails and a welcoming clubhouse, fosters a warm and engaging neighborhood environment. Choose Pelican Pointe for a lifestyle that blends relaxation and activity effortlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments Near 70458",
      "seo_description": "Explore modern one-bedroom apartments near 70458 at Pelican Pointe. Experience comfort in Slidell, LA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191762",
      "source": "generator",
      "page_item_url": "three-bedroom-units-st-tammany-parish",
      "search_query": "three bedroom units St Tammany Parish",
      "category": "Floorplan",
      "h1_title": "Spacious Three-Bedroom Units in St Tammany",
      "h2_subtitle": "Experience comfort in our three-bedroom units in St Tammany Parish. Pelican Pointe offers room to grow with luxury amenities for every lifestyle.",
      "page_copy": "Discover the perfect blend of space and luxury in the three-bedroom units at Pelican Pointe, located in St Tammany Parish. Our expansive floor plans provide the ideal backdrop for families or individuals seeking additional room to thrive. Each unit comes with high-end finishes like granite countertops and cable-ready setups, ensuring a modern and convenient lifestyle.\n\nPositioned within a vibrant community, Pelican Pointe enhances your living experience with a plethora of amenities. Enjoy carefree afternoons at the playground or unwind by the serene pond. Our clubhouse offers a place to socialize, while the walking trails provide an escape into nature right in your backyard. Join us at Pelican Pointe where comfort and community come together, creating a beautiful place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue and grey siding and gray roof.",
        "public_id": "019d076e-43c3-76bf-bd45-3ed6175ab8e0",
        "storage_key": "property/6737460151191762/019d076e-43c3-76bf-bd45-3ed6175ab8e0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Units in St Tammany Parish",
      "seo_description": "Explore spacious three-bedroom units at Pelican Pointe in St Tammany Parish. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3354"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483198"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973409"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KPMC7QKK"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "985-336-3366"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "985-336-3175"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "985-379-9587"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "985-336-3395"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "985-336-3385"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "985-379-9246"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "985-379-9530"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "985-336-3174"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "985-336-3331"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "985-304-9565"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "985-306-8831"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "985-336-3357"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "985-304-8241"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "985-616-6293"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "985-313-9753"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "985-304-9561"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "985-336-3397"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "985-332-1513"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321245818"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "985-287-4378"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "985-317-2699"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e172811ee679a6e7"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "985-616-6511"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "985-336-3327"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "985-336-3341"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "985-589-6536"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "985-336-3032"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "985-336-3399"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "985-336-3310"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.liveatpelicanpointe.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191762/019e8480-0d63-745c-904a-af1a4b7e32e1.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "985-379-7308"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "985-304-9565"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3354",
  "custom_repli_id": "5028483198",
  "custom_realpage_id": "4973409",
  "custom_knock_a_link": "https://www.liveatpelicanpointe.com?utm_knock=a",
  "custom_knock_g_link": "https://www.liveatpelicanpointe.com?utm_knock=g",
  "custom_knock_r_link": "https://www.liveatpelicanpointe.com?utm_knock=r",
  "custom_knock_w_link": "https://www.liveatpelicanpointe.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-KPMC7QKK",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.liveatpelicanpointe.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.liveatpelicanpointe.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.liveatpelicanpointe.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.liveatpelicanpointe.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.liveatpelicanpointe.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.liveatpelicanpointe.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "985-336-3366",
  "custom_knock_ads_link": "https://www.liveatpelicanpointe.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.liveatpelicanpointe.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "985-336-3175",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.liveatpelicanpointe.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.liveatpelicanpointe.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.liveatpelicanpointe.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.liveatpelicanpointe.com?utm_knock=psa",
  "custom_knock_r_number": "985-379-9587",
  "custom_knock_w_number": "985-336-3395",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "985-336-3385",
  "custom_knock_amap_link": "https://www.liveatpelicanpointe.com?utm_knock=amap",
  "custom_knock_ar_number": "985-379-9246",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "985-379-9530",
  "custom_knock_fb_number": "985-336-3174",
  "custom_knock_fl_number": "985-336-3331",
  "custom_knock_gp_number": "985-304-9565",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.liveatpelicanpointe.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "985-306-8831",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.liveatpelicanpointe.com?utm_knock=bcard",
  "custom_knock_bnr_number": "985-336-3357",
  "custom_knock_cfres_link": "https://www.liveatpelicanpointe.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "985-304-8241",
  "custom_knock_lgp_number": "985-616-6293",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.liveatpelicanpointe.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "985-313-9753",
  "custom_knock_psa_number": "985-304-9561",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "985-336-3397",
  "custom_knock_bandit_link": "https://www.liveatpelicanpointe.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.liveatpelicanpointe.com?utm_knock=flyers",
  "custom_knock_osoc_number": "985-332-1513",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321245818",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "985-287-4378",
  "custom_knock_cfres_number": "985-317-2699",
  "custom_knock_chatgpt_link": "https://www.liveatpelicanpointe.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "e172811ee679a6e7",
  "custom_knock_dirmail_link": "https://www.liveatpelicanpointe.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "985-616-6511",
  "custom_knock_propbro_link": "https://www.liveatpelicanpointe.com?utm_knock=propbro",
  "custom_knock_bandit_number": "985-336-3327",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "985-336-3341",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.liveatpelicanpointe.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "985-589-6536",
  "custom_knock_dirmail_number": "985-336-3032",
  "custom_knock_propbro_number": "985-336-3399",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "985-336-3310",
  "custom_knock_maintenance_link": "https://www.liveatpelicanpointe.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191762/019e8480-0d63-745c-904a-af1a4b7e32e1.mp4",
  "custom_knock_maintenance_number": "985-379-7308",
  "custom_ppc_tracking_phone_number": "985-304-9565"
};

export const generatedAt = '2026-10-07T17:16:03.963Z';
